import React, { useCallback, useEffect, useMemo, useState } from "react";
import "./staightPage.css";
import DashboardLayout from "../../layout/dashboardLayout";
import { ImageComponent } from "../../global/imageComponent";
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import Select from "react-select";

import {
  CustomAccordionBody,
  CustomAccordionHeader,
  CustomAccordionItem,
  CustomAccordionWrapper,
} from "../../global/customAccordion";
import { IoStar } from "react-icons/io5";
import { IoMdArrowDropup } from "react-icons/io";
import { IoMdArrowDropdown } from "react-icons/io";
import { FaHeart } from "react-icons/fa6";
import { IoCloseOutline } from "react-icons/io5";
import { IoInformationCircleOutline } from "react-icons/io5";
import { Images } from "../../../utility/image";
import { formatBetSlipPoint, formatOdds, formatPoint, formatTotalPoint } from "../../../utility/odds";
import {
  getDrawDisplayLabel,
  resolveH2hSides,
} from "../../../utility/h2hOutcomes";
import { WALLET_REFRESH_EVENT } from "../../../utility/walletRefresh";
import {
  buildBuyPointSelectOptions,
  findBuyPointOptionIndex,
  canShowBuyPointsUI,
  isBuyPointsEnabledForSport,
  isBuyPointsAdminEnabled,
  resolveBuyPointsForSlipItem,
  validateBuyPointsSlipBeforeSubmit,
} from "../../../utility/buyPointOptions";
import {
  buildLiveSportNavOptions,
  filterLiveGamesBySportTab,
  isLiveSportTabValid,
} from "../../../utility/liveSportNav";
import {
  filterLeagueOptionsForFavorites,
  isLeagueOptionValid,
} from "../../../utility/leagueNavOptions";
import {
  calculateTeaserPayout,
  formatTeaserAmericanOddsDisplay,
  formatTeaserChartLabel,
  getAllowedTeaserPoints,
  getTeaserAmericanOdds,
  resolveTeaserChartForLegs,
  sanitizeLegsForTeaser,
  adjustTeaserLine,
} from "../../../utility/teaserOdds";
import {
  addRecentGame,
  hydrateRecentGames,
  loadRecentGamesFromStorage,
  partitionFavoritesRecents,
  partitionFavoriteBoardGames,
  isFavoritesBoardFilter,
  isFavoritesLeagueAll,
  filterFavoriteGamesByLeague,
  removeRecentGame,
  saveRecentGamesToStorage,
  findGameIndexInList,
  getGameCardElementId,
} from "../../../utility/favoritesRecents";
import MatchLiveScorePanel from "../../common/MatchLiveScorePanel";
import EventExtraMarketsPanel from "../../common/EventExtraMarketsPanel";
import FavRecentMatchCard from "../../common/FavRecentMatchCard";
import {
  endedMatchSelectionMessage,
  getMatchPhase,
  isGameOpenForBetting,
} from "../../../utility/activeBetMatchMarkets";
import {
  LIVE_BOARD_SCORE_FALLBACK_MS,
  mergeLiveBoardScoreFields,
  mergeLiveBoardDelta,
  mergeLiveFieldsIntoGame,
} from "../../../utility/liveBoardScoreRefresh";
import { useLiveBoardSocket } from "../../../hooks/useLiveBoardSocket";

import { useGlobalContext } from "../../context/SocketContext";
import TicketComponent from "./ticketComponent";
import AllSportsSlider from "./allSportsSlider";
import SportsEventsSlider from "./sportsEventsSlider";
import SportsEventsSliderSkeleton from "./sportsEventsSliderSkeleton";
import { getDashboardBanners } from "../../actions/dashboardBanner";
import {
  DEFAULT_PRIMARY_BANNERS,
  DEFAULT_SECONDARY_BANNERS,
} from "../../../constants/defaultDashboardBanners";
import RadioSelector from "./radioSelector";
import BuilderSlider from "./builderSlider";
import CallBetsBetBuilderPanel from "./CallBetsBetBuilderPanel";
import CallBetSlipBuilder from "./CallBetSlipBuilder";
import CustomRangeComponent from "./customRangeComponent";
import CalculatorModel from "./calculatorModel";
import {
  addOrder,
  fillOpenSpots,
  getFavsport,
  getGamedata,
  getGamedatas,
  getLiveOddsList,
  getOddsList,
  getOddsListnextItems,
  getPointGames,
  getSingleOpenSpots,
  getWalletDetails,
  setFavsport,
} from "../../actions/gameSettings";
import { useDispatch, useSelector } from "react-redux";
import { formatEventKickoffUpperCase } from "../../lib/dateFormat";
import GameDateDisplay from "../../lib/GameDateDisplay";
import {
  appendUniqueOddsGames,
  dedupeOddsGames,
  getPreferredBookmaker,
} from "../../lib/oddsGames";
import {
  useHistory,
  useLocation,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
import { isEmpty } from "../../lib/isEmpty";
import { isMongoObjectId } from "../../lib/isMongoObjectId";
import { toastAlert } from "../../lib/toastAlert";
import { getPointsGames } from "../../routes/userroutefront";
import BetBuildComponent from "./betBuildComponent";
import MatchStatus from "../../lib/DateLive";
import { SET_CHECK_IND } from "../../constants";
import Loader from "../Loader";
import TeamLogo from "../../common/TeamLogo";
import SportIcon from "../../common/SportIcon";
import {
  fetchSportGroupIconMaps,
  resolveSportIconUrl,
} from "../../../services/sportGroupIcons";
import { useRef } from "react";
import {
  normalizeBetsForSubmit,
  extractParlayLegs,
  slipHasCallBet,
  slipIsCallBetOnly,
  validateCallBetLeg,
  applyCallBetValidationToLeg,
  sanitizeDesiredLineInput,
  sanitizeDesiredOddsInput,
} from "../../lib/betSlipBuyPoints";
import {
  computeHasMoreFromMeta,
  resolveOddsFeedUpdate,
} from "../../../utility/oddsFeedGuard";
import { formatMoney, roundMoney, calcWinFromRisk, calcRiskFromWin } from "../../lib/wagerFinancials";
import {
  recalculateCallBetPayout,
  resolveCallBetPriceForPayout,
} from "../../../utility/callBetDisplay";
import {
  calcParlayCombinedAmericanOdds,
  calcParlayPayout,
  formatAmericanOdds,
  getLegPricesFromSelections,
  PARLAY_MIN_LEGS,
} from "../../../utility/parlayOdds";
import {
  getParlayLegsFromSubmitData,
  resolveOrderSubmitErrorMessage,
  summarizeTicketValidationErrors,
  validateParlayBeforeSubmit,
} from "../../../utility/parlaySubmit";
import { isDTS } from "../../../utility/platform";
import {
  getBuyPointsLabel,
  getEntryTypeLabel,
  getFeaturedMarketLabel,
  getTerm,
} from "../../../utility/complianceCopy";
import {
  amountEmptyMessage,
  amountPositiveMessage,
  callEntriesSubmittedMessage,
  entryValidationFailedMessage,
  invalidEntryTypeMessage,
  oddsChangedMessage,
  parlayMinLegsMessage,
  prizeAmountLabel,
  sameEventComboMessage,
  teaserMoneylineBlockedMessage,
  teaserMoneylineMessage,
  teaserMoneylineSelectionsMessage,
} from "../../../utility/entryCopy";
import {
  applyUpdatedLegsToSlip,
  isOddsChangedResponse,
  recomputeParlaySlipPayout,
} from "../../../utility/acceptOddsChanges";
import AcceptOddsChangesControl from "../../betBuilder/AcceptOddsChangesControl";
import {
  isSameEventRestrictedTab,
  sanitizeLegsForParlaySameEvent,
  wouldCreateSameEventCombo,
} from "../../../utility/sameEventCombo";
import {
  ROUTES,
  ALL_SPORTS_KEY,
  LIVE_BOARD_KEY,
  allSportsPath,
  resolveBoardSportFromPath,
} from "../../../constants/routes";
import {
  addFundingBucket,
  getCoinModeBalance,
  useCoinMode,
} from "../../../context/CoinModeContext";
import { formatWagerAmount } from "../../../utility/wagerDisplay";
import { filterGamesByTeamQuery } from "../../../utility/phoneShell";
import { usePhoneShell } from "../../../context/PhoneShellContext";

/** Matches stacked layout (matches above bet builder) — same breakpoint as staightPage.css */
const MOBILE_LAYOUT_MAX_PX = 1200;
const MOBILE_MATCHES_INITIAL = 5;
const MOBILE_MATCHES_STEP = 5;
/**
 * Pseudo "sports" that are UI/route modes, not real sport groups in the DB.
 * They must never be sent to /get-Gamedata-User (no leagues exist for them).
 */
const AZ_BETTING = ALL_SPORTS_KEY;
const LIVE_MOBIUS = LIVE_BOARD_KEY;
const isSportGroup = (sport) =>
  Boolean(sport) && sport !== AZ_BETTING && sport !== LIVE_MOBIUS;

const getSportCategoryId = (sportTitle) =>
  `category-${String(sportTitle ?? "other")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")}`;

const groupGamesBySportTitle = (games) => {
  const groups = new Map();

  games.forEach((item, index) => {
    if (!getPreferredBookmaker(item?.bookmakers)) return;
    const title = item?.sport_title || "Other";
    if (!groups.has(title)) {
      groups.set(title, []);
    }
    groups.get(title).push({ item, index });
  });

  return Array.from(groups.entries()).map(([sportTitle, entries]) => ({
    sportTitle,
    entries,
  }));
};

const sportsEventsSlider = DEFAULT_PRIMARY_BANNERS;
const sportsEventsSlider2 = DEFAULT_SECONDARY_BANNERS;

// Built lazily, per render: labelText reads admin-configured DTS vocabulary via
// getTerm(), and site settings load asynchronously after this module is
// evaluated. A module-level array would capture the built-in defaults at import
// time and never reflect an admin rename.
const getAllSportsData = () => [
  // {
  //     subId: 8,
  //     labelText: "Live",
  //     navLink: "/live",
  //     isActive: false,
  //     iconSrc: "liveIcon",
  //     count: 18,
  // },
  {
    subId: 9,
    labelText: "Favorites",
    boardFilter: "favorites",
    isActive: false,
    iconSrc: "favoritesIcon",
  },

  // {
  //     subId: 10,
  //     labelText: "Call Bets",
  //     navLink: null,
  //     isActive: false,
  //     isExpand: false,
  //     iconSrc: "bonusIcon",
  // },
  {
    subId: 10,
    // compliance-ok: tab id arg for getEntryTypeLabel; player sees Target pick on DTS
    labelText: getEntryTypeLabel("Call Bets", isDTS()),
    navLink: ROUTES.callBet,
    isActive: false,
    // isExpand: false,
    iconSrc: "bonusIcon",
  },
  {
    subId: 11,
    labelText: isDTS() ? `Active ${getTerm("entry", { plural: true })}` : "Active Bets",
    navLink: ROUTES.openBet,
    isActive: false,
    isExpand: false,
    iconSrc: "betIcon",
  },
  {
    subId: 12,
    sportKey: LIVE_BOARD_KEY,
    labelText: "Live",
    isActive: false,
    iconSrc: "liveIcon",
  },
  {
    subId: 1,
    sportKey: ALL_SPORTS_KEY,
    labelText: isDTS() ? `A-Z ${getTerm("play")}` : "A-Z Betting",
    isActive: false,
    iconSrc: "aTozIcon",
  },
  // {
  //   subId: 2,
  //   labelText: "Baseball",
  //   isActive: false,
  //   navLink: "/baseball",
  //   iconSrc: "batBallIcon",
  // },
  // {
  //   subId: 3,
  //   labelText: "Foot ball",
  //   isActive: false,
  //   navLink: "/american-football",
  //   iconSrc: "foodBallIcon",
  // },
  // {
  //   subId: 5,
  //   labelText: "Cricket",
  //   isActive: false,
  //   navLink: "/cricket",
  //   iconSrc: "cricatIcon",
  // },
  // {
  //   subId: 4,
  //   labelText: "Basket ball",
  //   isActive: false,
  //   navLink: "/basketball",
  //   iconSrc: "ballIcon",
  // },
  // {
  //   subId: 6,
  //   labelText: "Boxing",
  //   isActive: false,
  //   navLink: "/boxing",
  //   iconSrc: "boxing",
  // },
  // {
  //   subId: 7,
  //   labelText: "Tennis",
  //   isActive: false,
  //   navLink: "/tennis",
  //   iconSrc: "tennesBallIcon",
  // },
];
/**
 * Board body. Must render as a child of DashboardLayout so usePhoneShell()
 * sees the PhoneShellProvider — searching from the phone top bar updates
 * boardQuery in that provider; reading it outside the provider always got "".
 */
function StaightBetPage(props) {
  const { coinMode } = useCoinMode();
  const wagerAmount = (amount) => formatWagerAmount(formatMoney(amount), coinMode);
  const { id } = useParams(); // ✅ gets from URL (/straight-bet/:id)
  const history = useHistory();
  const location = useLocation();
  const favoritesFilterOn = isFavoritesBoardFilter(location.search);
  const { boardQuery, enabled: phoneShellEnabled, setEntryOpen } = usePhoneShell();
  const appliedLeagueRef = useRef("");
  // Track Favorites filter transitions so leaving Favorites can restore the
  // full A-Z/sport board (league chip from Favorites must not stick).
  const wasFavoritesFilterRef = useRef(favoritesFilterOn);
  const resolveSelectedSport = () => {
    if (location.state?.selectedSport) {
      return location.state.selectedSport;
    }

    // The bare board route is used after login. Resolve it as all-sports
    // immediately rather than briefly treating "straight-entry" as a sport
    // before the effect redirects to the canonical all-sports URL.
    return resolveBoardSportFromPath(location.pathname) || ALL_SPORTS_KEY;
  };
  const currentRouteSport = useMemo(() => resolveSelectedSport(), [
    location.pathname,
    location.state?.selectedSport,
  ]);

  const [selectedSport, setSelectedSport] = useState(currentRouteSport);
  const [selectedGameKey, setSelectedGameKey] = useState({ tittle: "All", key: "All" })
  const [favGames, setFavGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [islogeedin, setisLogedIn] = useState(false)
  const [primaryBannerSlides, setPrimaryBannerSlides] = useState(null);
  const [bannersLoading, setBannersLoading] = useState(true);

  useEffect(() => {
    const loadDashboardBanners = async () => {
      try {
        const primaryRes = await getDashboardBanners();

        if (
          primaryRes.status &&
          !primaryRes.useStaticFallback &&
          primaryRes.result?.length
        ) {
          setPrimaryBannerSlides(
            primaryRes.result.map((banner) => ({
              _id: banner._id,
              imageUrl: banner.imageUrl,
              linkUrl: banner.linkUrl,
              title: banner.title,
            }))
          );
        } else {
          setPrimaryBannerSlides(null);
        }
      } catch (err) {
        setPrimaryBannerSlides(null);
      } finally {
        setBannersLoading(false);
      }
    };

    loadDashboardBanners();
  }, []);

  const primarySliderData = primaryBannerSlides ?? sportsEventsSlider;
  const secondarySliderData = sportsEventsSlider2;

  // const accountData = useSelector((state) => state.account);
  // Only reset the league chip when the board sport/route changes — never
  // while the player is picking a league (that used to force key back to All).
  useEffect(() => {
    console.log("useLocation", location.pathname, location.state?.selectedSport, currentRouteSport)
    if (currentRouteSport !== selectedSport) {
      setSelectedSport(currentRouteSport);
      setSelectedGameKey({ tittle: "All", key: "All" });
    }
  }, [
    currentRouteSport,
    location.pathname,
    location.state,
    selectedSport,
  ]);

  // Same window as backend isGameLive / MatchStatus / MatchLiveScorePanel.
  const updateStatus = (matchTime, game) =>
    getMatchPhase(matchTime, game) === "live";

  const UpcomingStatus = (matchTime, game) =>
    getMatchPhase(matchTime, game);


  useEffect(() => {
    if (isEmpty(id)) {
      history.replace(allSportsPath());
    }
  }, [history, id]);

  useEffect(() => {
    console.log("useparmsid", location.state, selectedSport);
  }, [location.state, selectedSport]);

  useEffect(() => {
    fetchSportGroupIconMaps().then(setSportIconMaps);
  }, []);
  const { globalState, setGlobalState, socket } = useGlobalContext();
  const dispatch = useDispatch();
  const handleShowTicket = () => {
    setGlobalState({ dashboardSidebar: !globalState.dashboardSidebar });
  };
  // states
  const [betTabName, setBetTabName] = useState("Straight Bet"); // compliance-ok: tab id, labels go through getEntryTypeLabel
  const [acceptOddsChanges, setAcceptOddsChanges] = useState(false);
  const [callBetListRefreshKey, setCallBetListRefreshKey] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [tabCount, setTabCount] = useState(1);
  const [highlightedGameId, setHighlightedGameId] = useState(null);
  const [allGameType, setAllGameType] = useState([]);
  const [gameList, setGameList] = useState([]);
  const [gameLiveData, setGameLiveData] = useState([]);
  const [sportIconMaps, setSportIconMaps] = useState({ groups: {}, titles: {} });
  const [liveGames, setLiveGame] = useState([]);
  const requestIdRef = useRef(0);
  const pageRequestIdRef = useRef(0);
  const oddsFeedContextRef = useRef("");
  const prevBetTabRef = useRef("Straight Bet"); // compliance-ok: tab id
  /** Scroll container for odds list — infinite scroll attaches here (not window). */
  const straightBetListScrollRef = useRef(null);
  const betBuildContainerRef = useRef(null);
  const [isMobileStacked, setIsMobileStacked] = useState(
    () =>
      typeof window !== "undefined" &&
      window.innerWidth <= MOBILE_LAYOUT_MAX_PX
  );
  const [mobileVisibleCount, setMobileVisibleCount] = useState(
    MOBILE_MATCHES_INITIAL
  );
  const [isChecked, setIschecked] = useState(false);
  const [isSelect, setIsselect] = useState([]);
  const [selectValue, setSelectValue] = useState(false);

  const [SelectTeam, setSelectTeam] = useState([]);
  const [errors, setErrors] = useState("");
  const [ticketArr, setticketArr] = useState(0);
  const [selectTicket, setselectTicket] = useState(0);
  /** Bet slip UI always reads/writes CheckInd[0]; do not shift index on each pick. */
  const BET_SLIP_INDEX = 0;
  const accountData = useSelector((state) => state.account);
  const [teaserPoints, setTeaserPoints] = useState(6);


  const [openSpot, setOpenSpot] = useState();
  const [ticketId, setTicketId] = useState();
  const [ticketCanvas, setTicketCanvas] = useState(false);

  // const [isOpen, setIsOpen] = useState(false);
  // const [betTabName, setBetTabName] = useState("Straight Bet");
  const [AddBet, setAddBet] = useState([]);
  const [selectionQueue, setSelectionQueue] = useState(true);
  // const [ticket, setTicket] = useState(0);
  const checkInd = useSelector(state => state.checkIndReducer.checkInd) || [];
  const [CheckInd, setCheckInd] = useState(checkInd);

  useEffect(() => {
    if (accountData?.emailId) {
      fetchWalletData();
      setisLogedIn(true);
    } else {
      setisLogedIn(false);
    }
  }, [accountData]);

  useEffect(() => {
    const handleWalletRefresh = () => {
      fetchWalletData();
    };

    window.addEventListener(WALLET_REFRESH_EVENT, handleWalletRefresh);
    return () => {
      window.removeEventListener(WALLET_REFRESH_EVENT, handleWalletRefresh);
    };
  }, [accountData?.emailId]);

  useEffect(() => {
    dispatch({ type: SET_CHECK_IND, data: CheckInd });
  }, [CheckInd, dispatch]);

  // Recover selections stored on wrong slip indices (legacy bug: selectTicket drift).
  useEffect(() => {
    setCheckInd((prev) => {
      if (!Array.isArray(prev) || prev.length <= 1) return prev;
      const stray = prev
        .slice(1)
        .flat()
        .filter((item) => item && item.id);
      if (stray.length === 0) return prev;
      const base = Array.isArray(prev[BET_SLIP_INDEX]) ? [...prev[BET_SLIP_INDEX]] : [];
      const seen = new Set(
        base.map((x) => x.CheckId || `${x.id}|${x.type}|${x.teamName}`)
      );
      for (const item of stray) {
        const key = item.CheckId || `${item.id}|${item.type}|${item.teamName}`;
        if (!seen.has(key)) {
          seen.add(key);
          base.push(item);
        }
      }
      return [base];
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- run once on mount
  }, []);


  const [BetPrice, setBetPrice] = useState();
  const [BetPoint, setBetPoint] = useState();

  const [Price, setPrice] = useState(0);

  const [parlyPayout, setparlyPayout] = useState(0);
  const [Win, setWin] = useState(0);
  const [Risk, setRisk] = useState(0);
  const [totalbetamount, settotalbetamount] = useState(0);
  const [errormsg, seterrormsg] = useState("");

  // const accountData = useSelector((state) => state.account);
  const [walletData, setwalletData] = useState([]);
  // const [errors1, setErrors] = useState("");
  // const [teaserStake, setTeaserStake] = useState(0);
  // const [buyPoints, setBuyPoints] = useState(6);

  const [teaserStakes, setTeaserStakes] = useState({});
  const [buyPointsMap, setBuyPointsMap] = useState({});

  const [totalBet, setTotalBet] = useState("");
  const [totalTeaserBet, settotalTeaserBet] = useState("");

  const [categoryData, setCatgoryData] = useState([])
  const getNextRequestId = () => {
    const requestId = requestIdRef.current + 1;
    requestIdRef.current = requestId;
    return requestId;
  };

  const normalizeGames = (result) => {
    let games = [];
    if (Array.isArray(result)) {
      games = result;
    } else if (result) {
      games = [result];
    }
    return dedupeOddsGames(games);
  };

  const applyLiveScoreGames = useCallback(
    (incoming) => {
      const liveGames = normalizeGames(incoming);
      if (selectedSport === LIVE_MOBIUS) {
        setLiveGame((prev) => mergeLiveBoardDelta(prev, liveGames));
        setGameLiveData((prev) => mergeLiveBoardDelta(prev, liveGames));
      } else {
        setGameLiveData((prev) => mergeLiveBoardScoreFields(prev, liveGames));
      }
      setSelectedTeam((prev) => mergeLiveFieldsIntoGame(prev, liveGames));
    },
    [selectedSport]
  );

  useLiveBoardSocket(applyLiveScoreGames);

  const buildOddsFeedContextKey = (sport, leagueKey = "All") =>
    `${sport || ""}:${leagueKey || "All"}`;

  const beginOddsFeedFetch = (contextKey, { keepExisting = false } = {}) => {
    const requestId = getNextRequestId();
    pageRequestIdRef.current = requestId;
    const isNewContext = oddsFeedContextRef.current !== contextKey;
    oddsFeedContextRef.current = contextKey;
    // Favorites enter reloads All — keep the prior board until the new feed
    // lands so we don't flash an empty spinner under the loader.
    if (isNewContext && !keepExisting) {
      setGameLiveData([]);
      setHasMore(true);
    } else if (isNewContext) {
      setHasMore(true);
    }
    return requestId;
  };

  const applyOddsFeedResult = (requestId, result, meta) => {
    if (requestId !== requestIdRef.current) {
      return { applied: false };
    }

    const nextGames = normalizeGames(result);
    let keptPrevious = false;

    setGameLiveData((prev) => {
      const resolved = resolveOddsFeedUpdate(prev, nextGames);
      keptPrevious = resolved.keptPrevious;
      return resolved.games;
    });

    if (keptPrevious) {
      toastAlert(
        "error",
        "Odds temporarily unavailable — showing last loaded games."
      );
    }

    setHasMore(computeHasMoreFromMeta(meta, nextGames.length));
    const nextPage =
      meta?.hasMore && Number.isFinite(Number(meta?.page))
        ? Number(meta.page) + 1
        : 1;
    setPage(nextPage);

    return { applied: true, keptPrevious, nextGames };
  };

  const fetchGameDataforCategory = async (gameType) => {
    console.log("gameTypegameType", gameType)
    try {
      if (gameType == "A-Z Betting") {
        const oddsData = await fetchOddsDetails({ sport_key: [{ title: AZ_BETTING, key: AZ_BETTING }] }) // compliance-ok: internal odds-API data key, not rendered text
      } else if (gameType == "livemobius") {
        const oddsData = await fetchLiveOddsDetails()
      } else if (gameType != "A-Z Betting") {
        let { status, message, result } = await getGamedata({ game: gameType },
          dispatch
        );

        if (status == true) {
          console.log("fetchGameDataFetchCallfetchGameDataFetchCallfetchGameDataforCategory", result);
          setCatgoryData(result);
          // Initial "All" view for a specific sport: load every event of every
          // league in one response (all: true), so no league is hidden behind
          // the 50-game page cap.
          const oddsData = await fetchOddsDetails({ sport_key: result, all: true })
        }
      }

    } catch (err) {
      console.log("err", err);
    }
  };

  // Loads leagues + odds for a real sport. Odds are fetched inside
  // fetchGameDataforCategory — do not read a return value (it is undefined).
  async function fetchDatas() {
    try {
      await fetchGameDataforCategory(selectedSport);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }

  // useEffect(() => {

  // }, [selectedSport, gameList]);

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${MOBILE_LAYOUT_MAX_PX}px)`);
    const syncLayout = (e) => setIsMobileStacked(e.matches);
    syncLayout(mq);
    mq.addEventListener("change", syncLayout);
    return () => mq.removeEventListener("change", syncLayout);
  }, []);

  useEffect(() => {
    setMobileVisibleCount(MOBILE_MATCHES_INITIAL);
    // Phone scroll lives on .childrenWrapper; desktop may use the center column.
    // Jump back to the top when the visible list shrinks (sport/league/search).
    const shellScroller = document.querySelector(".phone-shell .childrenWrapper");
    if (shellScroller) shellScroller.scrollTop = 0;
    if (straightBetListScrollRef.current) {
      straightBetListScrollRef.current.scrollTop = 0;
    }
  }, [selectedSport, selectedGameKey?.key, boardQuery]);

  useEffect(() => {
    console.log("gameListgameList", selectedSport)
    setPage(1);
    setHasMore(true);
    setMobileVisibleCount(MOBILE_MATCHES_INITIAL);
    if (selectedSport === "A-Z Betting") {
      fetchOddsDetails({ sport_key: [{ title: AZ_BETTING, key: AZ_BETTING }] }); // compliance-ok: internal odds-API data key, not rendered text
    } else if (selectedSport === "livemobius") {
      fetchLiveOddsDetails();
    } else {
      fetchDatas();
    }

  }, [selectedSport]);


  // const addNewOrder = async (data,type) => {
  //   console.log("datadatadata", data);

  //   try {
  //     if (!isEmpty(id) && !isEmpty(ticketId)) {
  //       let vald = await ticketValidaion(data,type);
  //       console.log("1111111111111", vald)
  //       if (isEmpty(vald)) {
  //         let oj = {
  //           data: data,
  //           betType: betTabName,
  //           email: accountData.emailId,
  //           openSpots: openSpot,
  //           _id: id,
  //         };

  //         let { status, message, result } = await fillOpenSpots(oj);
  //         if (status == true) {
  //           History.push("/fillopen");
  //           toastAlert("success", "Bet Placed Successfully");
  //         } else {
  //           toastAlert("error", message);
  //           // History.push("/fillopen");
  //         }
  //       }
  //     } else {
  //       let vald = await ticketValidaion(data,type);
  //       console.log("1111111111112", vald)
  //       if (isEmpty(vald)) {
  //         let oj = {
  //           data: data,
  //           betType: betTabName,
  //           email: accountData?.emailId,
  //           openSpots: openSpot,
  //         };
  //         let { status, message, result } = await addOrder(oj);
  //         if (status == true) {
  //           console.log(openSpot, "openSpotopenSpot");
  //           History.push("/openbet");
  //           toastAlert("success", "Bet Placed Successfully");
  //         } else {
  //           toastAlert("error", message);
  //         }
  //       }
  //     }
  //   } catch (err) {
  //     console.log("err", err);
  //   }
  // };
  // const ticketValidaion = async (data,type) => {
  //   console.log("data.Price", data);
  //   try {
  //     let errors = {};
  //     let datas = [];

  //     for (let i = 0; i < data?.length; i++) {
  //       console.log("data[i][j]?.Price", data[i]);
  //       let obj = {};
  //           obj["Price"] = "bet Amount shouldn't be empty";
  //           datas[i] = obj; // store validation error for this row
  //           errors["data"] = datas;

  //       // for (let j = 0; j < data[i]?.length; j++) {
  //       //   console.log("data[i][j]?.Price", data[i][j]);
  //       //   if (isEmpty(data[i][j]?.Price)) {
  //       //     let obj = {};
  //       //     obj["Price"] = "bet Amount shouldn't be empty";
  //       //     datas[i] = obj; // store validation error for this row
  //       //     errors["data"] = datas;
  //       //   }
  //       // }
  //     }

  //     setErrors(errors);
  //     return errors;
  //   } catch (err) {
  //     console.log(err, "ticketValidaion");
  //   }
  // };

  // Clears every piece of bet-slip state and synchronously syncs it
  // to Redux. We must dispatch synchronously here (rather than relying
  // on the [CheckInd]-keyed useEffect) because a navigation can unmount
  // this component before that effect runs, leaving stale selections
  // in the store. When the user later returns to this page (or visits
  // /live and comes back) the page would otherwise re-hydrate from the
  // stale Redux state and the odds would still appear selected.
  const refreshSlipFromOddsChanged = (updatedLegs, type) => {
    setCheckInd((prev) => {
      const current = Array.isArray(prev?.[0]) ? prev[0] : [];
      let { legs } = applyUpdatedLegsToSlip(current, updatedLegs);
      if (type === "parlay") {
        legs = recomputeParlaySlipPayout(legs, totalBet);
      }
      return [legs];
    });
  };

  const resetBetSlip = () => {
    const empty = [[]];
    setCheckInd(empty);
    dispatch({ type: SET_CHECK_IND, data: empty });
    setIsselect([]);
    setSelectTeam([]);
    setticketArr(0);
    setselectTicket(0);
    setOpenSpot(undefined);
    setTotalBet("");
    settotalTeaserBet("");
    setparlyPayout(0);
    setRisk(0);
    setWin(0);
    setPrice(0);
    settotalbetamount(0);
    setAcceptOddsChanges(false);
    setErrors("");
    seterrormsg("");
  };

  const resolveApiBetType = (tabName) =>
    tabName === "Call Bets" ? "Straight Bet" : tabName; // compliance-ok: API entry-type value

  const addNewOrder = async (data, type) => {
    console.log("🟡 datadatadata", data, "type:", type);

    try {
      if (!islogeedin) {
        toastAlert("error", isDTS() ? `Please login to place ${getTerm("entry", { case: "lower" })}` : "Please login to place a bet");
        history.push("/login");
        return;
      }

      // DTS submissions must validate the same wallet selected in the global
      // header switcher. Fill-open additions deliberately keep the original
      // order's stored funding bucket; the backend validates that bucket.
      const isExistingOpenOrder = !isEmpty(id) && !isEmpty(ticketId);
      const wallet = walletData?.walletData || {};
      const availableBalance = isDTS()
        ? getCoinModeBalance(wallet, coinMode)
        : Number(wallet.userBalance || 0);
      let totalRequired = 0;

      if (type === "straight") {
        totalRequired = data.reduce((sum, item) => sum + (Number(item.Price) || 0), 0);

        const isCallLeg = (item) =>
          item.isCallBetType === true || item.isCallBetType === "true";
        const hasCallBetLeg = data.some(isCallLeg);

        if (betTabName === "Straight Bet" && hasCallBetLeg) {
          toastAlert(
            "error",
            isDTS()
              ? `Target picks must be placed from the Target pick tab in the ${getTerm("entry", { case: "lower" })} builder`
              : "Call bets must be placed from the Call Bets tab in the bet builder"
          );
          return;
        }

        if (betTabName === "Call Bets") {
          if (!data.length) {
            toastAlert("error", isDTS() ? "Select a match from the board to place a Target pick" : "Select a match from the board to place a call bet");
            return;
          }
          for (const item of data) {
            const check = validateCallBetLeg(item);
            if (!check.ok) {
              toastAlert("error", check.message);
              return;
            }
            if (!item.Price || Number(item.Price) <= 0) {
              toastAlert(
                "error",
                `Enter a risk amount for ${item.teamName || "each selection"}`
              );
              return;
            }
          }
        }

        for (const item of data) {
          const isCall = isCallLeg(item);
          if (!isCall) continue;

          if (!item.Price || Number(item.Price) <= 0) {
            toastAlert("error", isDTS() ? "Enter risk amount for Target pick legs" : "Enter risk amount for call bet legs");
            return;
          }

          const check = validateCallBetLeg(item);
          if (!check.ok) {
            toastAlert("error", check.message);
            return;
          }
        }
      } else if (type === "parlay") {
        totalRequired = Number(totalBet) || 0;
      } else if (type === "teaser") {
        totalRequired = Number(totalTeaserBet) || 0;
      }

      if (!isExistingOpenOrder && totalRequired > availableBalance) {
        toastAlert("error", "Insufficient balance. Redirecting to wallet to add funds...");
        setTimeout(() => {
          history.push("/wallet");
        }, 2000);
        return;
      }
      // ✅ Validate parlay input
      if (type === "parlay") {
        const parlayCheck = validateParlayBeforeSubmit({
          legs: getParlayLegsFromSubmitData(data),
          stake: totalBet,
        });
        if (!parlayCheck.ok) {
          toastAlert("error", parlayCheck.message);
          return;
        }
      }

      // ✅ Validate teaser input
      if (type === "teaser") {
        if (isEmpty(totalTeaserBet)) {
          toastAlert(
            "error",
            isDTS()
              ? `Please enter the amount for ${getEntryTypeLabel("Teaser", true)} ${getTerm("entry", { case: "lower" })}`
              : "Please enter the amount for teaser bet"
          );
          return;
        } else if (Number(totalTeaserBet) <= 0) {
          toastAlert("error", "Please enter a valid amount");
          return;
        }

        const chartCheck = resolveTeaserChartForLegs(data);
        if (!chartCheck.ok) {
          toastAlert("error", chartCheck.message);
          return;
        }

        const hasH2H = Array.isArray(data) && data.some(item => item.type === "h2h");
        if (hasH2H) {
          toastAlert("error", `Failed to place order — ${teaserMoneylineMessage()}`);
          return;
        }
      }

      // ✅ Fix for Parlay: group all selections into one single array
      let formattedData = data;
      if (type === "straight" || type === "parlay") {
        const slipRows = Array.isArray(data) ? data : [data];
        const preparedRows =
          betTabName === "Call Bets"
            ? slipRows.map(applyCallBetValidationToLeg)
            : slipRows;
        formattedData = normalizeBetsForSubmit(preparedRows, type);
        console.log("🟢 Bets with buyPoints for submit:", formattedData);

        const buyPointsCheck = validateBuyPointsSlipBeforeSubmit(
          formattedData,
          betTabName
        );
        if (!buyPointsCheck.ok) {
          toastAlert("error", buyPointsCheck.message);
          return;
        }

        if (type === "parlay") {
          const parlayCheck = validateParlayBeforeSubmit({
            legs: getParlayLegsFromSubmitData(formattedData),
            stake: totalBet,
          });
          if (!parlayCheck.ok) {
            toastAlert("error", parlayCheck.message);
            return;
          }
        }
      }

      // Add the selected ledger bucket only for a new prediction. Existing
      // fill-open orders must remain on the bucket recorded at their creation.
      const submissionData = isDTS() && !isExistingOpenOrder
        ? addFundingBucket(formattedData, coinMode)
        : formattedData;

      // ✅ Validate ticket if existing
      if (isExistingOpenOrder) {
        let vald = await ticketValidaion(submissionData, type);
        console.log("🧩 Validation result (existing ticket):", vald);

        if (isEmpty(vald)) {
          const oj = {
            data: submissionData,
            betType: resolveApiBetType(betTabName),
            email: accountData.emailId,
            openSpots: openSpot,
            _id: id,
          };

          const { status, message } = await fillOpenSpots(oj);
          if (status === true) {
            resetBetSlip();
            history.push("/fillopen");
            toastAlert("success", isDTS() ? `${getTerm("entry")} Placed Successfully` : "Bet Placed Successfully");
          } else {
            toastAlert(
              "error",
              resolveOrderSubmitErrorMessage({ message }, null)
            );
          }
        } else {
          const summary = summarizeTicketValidationErrors(vald);
          if (summary) toastAlert("error", summary);
        }
      } else {
        // ✅ For new tickets
        let vald = await ticketValidaion(submissionData, type);
        console.log("🧩 Validation result (new ticket):", vald);

        if (isEmpty(vald)) {
          const oj = {
            data: submissionData,
            betType: resolveApiBetType(betTabName),
            email: accountData?.emailId,
            openSpots: openSpot,
            acceptOddsChanges,
          };

          const { status, message, code, updatedLegs } = await addOrder(oj);

          if (status === true) {
            console.log("🟢 openSpot:", openSpot);
            const hasCallBet = type === "straight" && slipHasCallBet(formattedData);
            const callBetOnly =
              type === "straight" && slipIsCallBetOnly(formattedData);
            resetBetSlip();
            if (callBetOnly) {
              setBetTabName("Call Bets"); // compliance-ok: tab id
              setCallBetListRefreshKey((k) => k + 1);
              toastAlert("success", callEntriesSubmittedMessage(formattedData.length));
            } else if (hasCallBet) {
              history.push(ROUTES.openBet);
              toastAlert(
                "success",
                isDTS()
                  ? `${getTerm("entry", { plural: true })} placed. Target pick legs are pending activation.`
                  : "Bets placed. Call bet legs are pending activation."
              );
            } else {
              history.push(ROUTES.openBet);
              toastAlert("success", isDTS() ? `${getTerm("entry")} Placed Successfully` : "Bet Placed Successfully");
            }
          } else if (isOddsChangedResponse({ status, code, message })) {
            refreshSlipFromOddsChanged(updatedLegs, type);
            toastAlert("error", message || oddsChangedMessage(), "odds-changed");
          } else {
            toastAlert(
              "error",
              resolveOrderSubmitErrorMessage({ message }, null)
            );
          }
        } else {
          const summary = summarizeTicketValidationErrors(vald);
          if (summary) toastAlert("error", summary);
        }
      }
    } catch (err) {
      console.log("❌ addNewOrder_error", err);
      toastAlert(
        "error",
        resolveOrderSubmitErrorMessage(null, err)
      );
    }
  };





  const ticketValidaion = async (data, type) => {
    console.log("Validating bets for type:", type, "data:", data);
    try {
      let errors = {};
      let datas = [];

      const validTypes = ["teaser", "straight", "parlay"];
      if (!validTypes.includes(type)) {
        errors["type"] = invalidEntryTypeMessage(type);
        toastAlert("error", isDTS() ? `Invalid ${getTerm("entry", { case: "lower" })} type` : "Invalid bet type");
        setErrors(errors);
        return errors;
      }

      if (type === "parlay") {
        const parlayCheck = validateParlayBeforeSubmit({
          legs: getParlayLegsFromSubmitData(data),
          stake: totalBet,
        });
        if (!parlayCheck.ok) {
          errors.legs = parlayCheck.message;
          toastAlert("error", parlayCheck.message);
          setErrors(errors);
          return errors;
        }
        setErrors(errors);
        return errors;
      }

      if (type === "teaser") {
        const enteredAmount = Number(totalTeaserBet);
        if (!enteredAmount || enteredAmount <= 0) {
          errors["amount"] = amountPositiveMessage();
          toastAlert("error", amountPositiveMessage());
        }
        setErrors(errors);
        return errors;
      }

      // ✅ Validate straight bet amounts
      for (let i = 0; i < data?.length; i++) {
        if (!data[i] || typeof data[i] !== "object" || Array.isArray(data[i])) {
          continue;
        }
        data[i].Price = Math.abs(data[i].Price);
        console.log("data[i]", data[i]);
        const { risk, win } = data[i] || {};
        if (data[i].activatedTab === type) {
          if (isEmpty(risk) || isEmpty(win) || isEmpty(data[i].Price)) {
            let obj = {};
            obj["Price"] = amountEmptyMessage();
            datas[i] = obj;
            toastAlert("error", amountEmptyMessage());
            break;
          } else if (risk <= 0 || win <= 0 || data[i].Price <= 0) {
            let obj = {};
            obj["Price"] = amountPositiveMessage();
            datas[i] = obj;
            toastAlert("error", amountPositiveMessage());
            break;
          }
        } else if (isEmpty(data[i].activatedTab)) {
          if (isEmpty(risk) && isEmpty(win)) {
            let obj = {};
            obj["Price"] = amountEmptyMessage();
            datas[i] = obj;
            toastAlert("error", amountEmptyMessage());
            break;
          }
        } else if (data[i].activatedTab !== type) {
          let obj = {};
          obj["Price"] = amountEmptyMessage();
          datas[i] = obj;
          toastAlert("error", isDTS() ? `already selected ${getTerm("entry", { case: "lower" })} please select another ${getTerm("entry", { case: "lower" })} value` : "already selected bet please select another bet value");
          break;
        }
      }


      if (datas.length > 0) {
        errors["data"] = datas;
      }

      console.log("Validation Errors:", errors);
      setErrors(errors);
      return errors;
    } catch (err) {
      console.log(err, "ticketValidaion");
      const errors = {
        validation: entryValidationFailedMessage(),
      };
      toastAlert("error", errors.validation);
      setErrors(errors);
      return errors;
    }
  };





  const handleChecked = (e, index) => {
    if (e == true && index == 0) {
      setIschecked(true);
    } else {
      setIschecked(false);
    }
  };

  const handleselect = (val) => {
    let IsSelect = [...isSelect];
    IsSelect[selectTicket] = val;
    setIsselect(IsSelect);
  };

  const setOpenSpotsCount = (val) => {
    let OpenSpot = [];
    // OpenSpot[selectTicket] = val;
    OpenSpot.push(val);
    setOpenSpot(OpenSpot);
  };

  const handleselect2 = (val) => {
    setSelectValue(val);
  };

  const [isCheckAll, setIsCheckAll] = useState([]);
  // const [CheckInd, setCheckInd] = useState([]);
  const [isBuyPoints, setIsBuyPoints] = useState();

  const teamsSelect = async (e, item) => {

    if (e.target.checked) {
      const currentSlip = CheckInd?.[BET_SLIP_INDEX] || [];

      if (
        isSameEventRestrictedTab(betTabName) &&
        wouldCreateSameEventCombo(currentSlip, item)
      ) {
        e.target.checked = false;
        toastAlert("error", sameEventComboMessage(), "same-event-combo");
        return;
      }

      if (betTabName === "Teaser") {
        const chartCheck = resolveTeaserChartForLegs([...currentSlip, item]);
        if (!chartCheck.ok) {
          e.target.checked = false;
          toastAlert("error", chartCheck.message, "teaser-validation");
          return;
        }
      }

      // Add to slip immediately so + More / board clicks feel instant.
      // Buy-points admin flag loads after and patches the leg.
      const buildNextItem = (BuyPoints) => {
        let nextItem = {
          ...item,
          buypoint: BuyPoints,
          originalPoint: item.point,
          originalPrice: item.price,
          desiredPoint: "",
          desiredPrice: "",
          isCallBetType: "false",
        };

        // Teaser: buyPoints = teaser legs (6 / 6.5 / …); straight/parlay: buy half-points via UI (delta), default 0.
        if (betTabName === "Teaser") {
          const seedBuyPoints = Number(teaserPoints);
          const seedAdjusted = adjustTeaserLine(
            { ...item, buyPoints: seedBuyPoints },
            seedBuyPoints
          );
          nextItem = {
            ...nextItem,
            buyPoints: seedBuyPoints,
            adjustedPoint: seedAdjusted,
          };
        } else {
          nextItem = {
            ...nextItem,
            buyPoints: 0,
          };
        }
        return nextItem;
      };

      setCheckInd((prev) => {
        const next = JSON.parse(JSON.stringify(prev));
        let checkArr = next[BET_SLIP_INDEX] || [];

        // ✅ 1. Prevent duplicates of the same outcome
        // ✅ 2. Enforce only one active selection per market type (Spread / M-Line / Total) per match
        const filteredArr = checkArr.filter(
          (val) => !(val.id === item.id && val.type === item.type)
        );

        filteredArr.push(buildNextItem(false));
        next[BET_SLIP_INDEX] = filteredArr;
        return next;
      });

      // Phone/tablet: Entry Builder is a sheet — open it so the pick is visible.
      if (phoneShellEnabled && typeof setEntryOpen === "function") {
        setEntryOpen(true);
      }

      const BuyPoints = await fetchPointGames(item.sport_title, item);
      if (BuyPoints) {
        setCheckInd((prev) => {
          const next = JSON.parse(JSON.stringify(prev));
          const checkArr = next[BET_SLIP_INDEX] || [];
          const idx = checkArr.findIndex((val) =>
            item.CheckId
              ? val.CheckId === item.CheckId
              : val.id === item.id &&
                val.type === item.type &&
                val.teamName === item.teamName
          );
          if (idx === -1) return prev;
          checkArr[idx] = {
            ...checkArr[idx],
            buypoint: BuyPoints,
          };
          next[BET_SLIP_INDEX] = checkArr;
          return next;
        });
      }
    } else {
      setCheckInd((prev) => {
        const next = JSON.parse(JSON.stringify(prev));
        let checkArr = next[BET_SLIP_INDEX] || [];

        const fidIndxx = checkArr.findIndex((val) =>
          item.CheckId
            ? val.CheckId === item.CheckId
            : val.id === item.id &&
              val.type === item.type &&
              val.teamName === item.teamName
        );

        if (fidIndxx !== -1) {
          checkArr.splice(fidIndxx, 1);
          next[BET_SLIP_INDEX] = checkArr;
          return next;
        }
        return prev;
      });
    }
  };

  const fetchPointGames = async (gameTitle, slipItem) => {
    try {
      const { status, result } = await getPointGames({ title: gameTitle });
      return resolveBuyPointsForSlipItem(status, result, gameTitle, slipItem);
    } catch (err) {
      console.log(err, "ERR");
      return false;
    }
  };

  useEffect(() => {
    const legs = CheckInd?.[BET_SLIP_INDEX] || [];
    const titles = [
      ...new Set(legs.map((item) => item?.sport_title).filter(Boolean)),
    ];
    if (!titles.length) {
      setBuyPointsMap({});
      return;
    }

    let cancelled = false;
    (async () => {
      const next = {};
      await Promise.all(
        titles.map(async (title) => {
          try {
            const { status, result } = await getPointGames({ title });
            next[String(title).trim().toLowerCase()] = isBuyPointsAdminEnabled(
              status,
              result,
              title
            );
          } catch {
            next[String(title).trim().toLowerCase()] = false;
          }
        })
      );
      if (!cancelled) setBuyPointsMap(next);
    })();

    return () => {
      cancelled = true;
    };
  }, [CheckInd]);

  const getOpenSpotDetails = async () => {
    if (!isMongoObjectId(id)) return;
    try {
      let { status, message, result } = await getSingleOpenSpots({ _id: id });
      if (!status || !result?.bettingData) return;
      let betArray = [];
      let array = [];
      let opArray = [];
      for (let i = 0; i < result.bettingData.length; i++) {
        let data = {
          CheckId: "00",
          awayTeam: result.bettingData[i].awayTeam,
          gameTime: result.bettingData[i].gameTime,
          homeTeam: result.bettingData[i].homeTeam,
          id: result.bettingData[i].gameId,
          price: result.bettingData[i].price,
          sport_key: result.bettingData[i].keyName,
          sport_title: result.bettingData[i].title,
          teamName: result.bettingData[i].teamName,
          type: result.bettingData[i].oddType,
          Price: result.bettingData[i].wagerAmount,
          payout: result.bettingData[i].payOut,
        };
        betArray.push(data);
      }
      array.push(betArray);
      setCheckInd(array);
      let opt = options.find((val) => val.value == result.betType);
      opArray.push(opt);
      setIsselect(opArray);
      setOpenSpot(result.openSpots);
      setTicketId(result.ticketId);
      // setTicket={() => {
      console.log("ticketArr-1", result);

      setticketArr(ticketArr + 1);
      setselectTicket(ticketArr);
      // }}
    } catch (err) {
      console.log(err, "ERR");
    }
  };


  const getCurrentSelectValue = (val) => {
    setBetTabName(val);
  };

  useEffect(() => {
    const prevTab = prevBetTabRef.current;
    const switchedToTeaser = betTabName === "Teaser" && prevTab !== "Teaser";
    const switchedToParlay =
      betTabName === "Parlay Bet" && prevTab !== "Parlay Bet";
    prevBetTabRef.current = betTabName;

    const currentSlip = Array.isArray(CheckInd?.[0]) ? CheckInd[0] : [];
    if (!currentSlip.length) return;

    if (switchedToTeaser) {
      const { legs, changed, message } = sanitizeLegsForTeaser(currentSlip);
      if (!changed) return;
      setCheckInd((prev) => {
        const next = JSON.parse(JSON.stringify(prev));
        next[0] = legs;
        return next;
      });
      if (message) {
        toastAlert("error", message, "teaser-validation");
      }
      return;
    }

    // Teaser (and other tabs) may carry multiple picks from one event; Parlay
    // keeps the first per event so the slip matches the Function Rule.
    if (switchedToParlay) {
      const { legs, changed, message } =
        sanitizeLegsForParlaySameEvent(currentSlip);
      if (!changed) return;
      setCheckInd((prev) => {
        const next = JSON.parse(JSON.stringify(prev));
        next[0] = legs;
        return next;
      });
      if (message) {
        toastAlert("error", message, "same-event-combo");
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [betTabName]);

  const [selectedTeam, setSelectedTeam] = useState()
  const showFullDetailHandle = (item) => {
    console.log("item-showFullDetailHandle", item);
    setSelectedTeam(item)
    tabNavigateHandle(2);
  };

  const tabNavigateHandle = (number = 1) => {
    setTabCount(number);
  };

  // Sidebar / URL sport changes must leave match detail and show that
  // sport's list. Without this, tabCount stays on detail and the old
  // match keeps rendering while the address bar already moved.
  // Declared before the Favorites preselect effect so a deep-link with
  // selectedTeam can re-open detail in the same commit after this reset.
  useEffect(() => {
    setSelectedTeam(undefined);
    setTabCount(1);
  }, [currentRouteSport]);

  // If we were navigated here with a preselected match (e.g. from the
  // Favorites page), open its details view automatically. Prefer the
  // fresh copy from gameLiveData (so odds/markets are current), and
  // fall back to whatever was passed in state. Clear the consumed
  // state from history so it does not re-trigger on subsequent renders.
  useEffect(() => {
    const incoming = location.state?.selectedTeam;
    if (!incoming) return;

    const fresh =
      Array.isArray(gameLiveData) &&
      gameLiveData.find((g) => g?.id === incoming.id);
    const target = fresh || incoming;

    setSelectedTeam(target);
    setTabCount(2);

    const { selectedTeam: _consumed, ...restState } = location.state || {};
    history.replace(location.pathname, restState);
  }, [location.state, gameLiveData, history, location.pathname]);

  const fetchGameDataFetchCall = async (gameType) => {
    try {
      let { status, message, result } = await getGamedata({ game: gameType },
        dispatch
      );
      console.log("fetchGameDataFetchCallfetchGameDataFetchCall", status, message, result);
      if (status == true) {
        setGameList(result);
      }
    } catch (err) {
      console.log("err", err);
    }
  };
  const fetchGameDatasFetchCall = async () => {
    try {
      let { status, message, result } = await getGamedatas(dispatch);
      console.log("getGamedatas --->fetchGameDatasFetchCall", { status, message, result });
      if (status == true) setAllGameType(result);
    } catch (err) {
      console.log("err-fetchGameDatasFetchCall", err);
    }
  };

  const fetchWalletData = async () => {
    if (!accountData?.emailId) return;
    try {
      let { status, message, result } = await getWalletDetails({
        email: accountData.emailId,
      });
      if (status == true) {
        setwalletData(result);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  const allItems = CheckInd?.flat() || [];

  const totalRisk = allItems.reduce((sum, item) => sum + (parseFloat(item.risk) || 0), 0);
  const totalWin = allItems.reduce((sum, item) => sum + (parseFloat(item.win) || 0), 0);
  const totalPayout = allItems.reduce((sum, item) => sum + (parseFloat(item?.payout) || 0), 0);

  const parlaySlip = CheckInd?.[BET_SLIP_INDEX] || [];
  const parlayLegPriceKey = parlaySlip
    .map((l) => `${l?.id}-${l?.price}-${l?.point}`)
    .join("|");

  const parlayLegPrices = useMemo(
    () => getLegPricesFromSelections(CheckInd?.[BET_SLIP_INDEX] || []),
    // parlayLegPriceKey tracks leg price/point changes without unstable [] fallback refs.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [parlayLegPriceKey]
  );

  const parlayCombinedOdds = useMemo(
    () => calcParlayCombinedAmericanOdds(parlayLegPrices),
    [parlayLegPrices]
  );

  const parlayHasValidLegPrices =
    parlaySlip.length > 0 && parlayLegPrices.length === parlaySlip.length;

  const parlayDisplayPayout = useMemo(() => {
    const bet = Number(totalBet);
    if (!Number.isFinite(bet) || bet <= 0 || !parlayHasValidLegPrices) return 0;
    return roundMoney(calcParlayPayout(bet, parlayLegPrices).payout);
  }, [totalBet, parlayLegPrices, parlayHasValidLegPrices]);



  const handleAddBet = () => {
    setAddBet([...AddBet, { id: Math.random().toString().slice(2, 6) }]);
  };

  const [options, setoptions] = useState([{ title: "All", key: "All" }]);
  /** Full league catalog for the selected sport (before empty-league filtering). */
  const [leagueCatalogOptions, setLeagueCatalogOptions] = useState([
    { title: "All", key: "All" },
  ]);






  const handleRemoveTab = (item, index) => {
    const newAdd = [...(CheckInd[BET_SLIP_INDEX] || [])];
    newAdd.splice(index, 1);
    setCheckInd([newAdd]);
    dispatch({ type: SET_CHECK_IND, data: [newAdd] });
  };

  const fetchAlloptionForSelectedGames = async (existingRequestId = null) => {
    const contextKey = buildOddsFeedContextKey(selectedSport, "All");
    const requestId = existingRequestId ?? beginOddsFeedFetch(contextKey);
    const managesLoading = existingRequestId == null;
    if (managesLoading) {
      setInitialLoading(true);
    }
    try {
      let { status, message, result } = await getGamedata(
        { game: selectedSport },
        dispatch
      );
      if (requestId !== requestIdRef.current) {
        return;
      }
      // "All" shows every event of every league at once (grouped by league in
      // the list). `all: true` tells the backend to return the whole board in a
      // single response instead of the first 50, so no league is hidden behind
      // infinite scroll.
      const data = { sport_key: result, all: true };
      const gamedatas = await getOddsList(data, dispatch);
      if (requestId !== requestIdRef.current) {
        return;
      }
      applyOddsFeedResult(requestId, gamedatas?.result, gamedatas?.meta);
    } catch (err) {
      if (requestId !== requestIdRef.current) {
        return;
      }
      console.log("err", err);
      setHasMore(false);
    } finally {
      if (managesLoading && requestId === requestIdRef.current) {
        setInitialLoading(false);
      }
    }
  };

  const fetchGameDatas = async () => {
    const allOption = { title: "All", key: "All" };

    // "A-Z Betting" / "livemobius" are UI modes, not real sport groups, so
    // there are no leagues to fetch — only the default "All" option applies.
    if (!isSportGroup(selectedSport)) {
      setLeagueCatalogOptions([allOption]);
      setoptions([allOption]);
      return;
    }

    try {
      let { status, message, result } = await getGamedata({ game: selectedSport }, dispatch);

      if (status == true) {
        const catalog = [allOption, ...result];
        setLeagueCatalogOptions(catalog);
        // Full league chip row from catalog; selection highlight is separate.
        setoptions(catalog);
      }
    } catch (err) {
      console.log("err", err);
    }
  };



  useEffect(() => {
    fetchGameDatas();
  }, [selectedSport]);

  // League chips: show every admin-enabled league for this sport group; highlight
  // the selected chip. Do not trim chips when a single-league odds fetch narrows
  // gameLiveData — that hid NFL/NCAAF/etc. and left only All + current league.
  // Favorites still trims to leagues that have a starred match on the board.
  useEffect(() => {
    if (!isSportGroup(selectedSport)) return;

    const nextOptions = favoritesFilterOn
      ? filterLeagueOptionsForFavorites(
          leagueCatalogOptions,
          favGames,
          gameLiveData
        )
      : leagueCatalogOptions;
    setoptions(nextOptions);

    if (
      selectedGameKey?.key !== "All" &&
      !isLeagueOptionValid(nextOptions, selectedGameKey)
    ) {
      setSelectedGameKey({ title: "All", key: "All" });
    }
  }, [
    selectedSport,
    gameLiveData,
    leagueCatalogOptions,
    favoritesFilterOn,
    favGames,
    selectedGameKey?.key,
  ]);

  useEffect(() => {
    if (selectedSport !== LIVE_MOBIUS && selectedSport !== AZ_BETTING) return;

    // A-Z keeps the full tab list while a single league is loaded via API.
    // Favorites still refreshes chips from the full All feed so only starred
    // leagues stay visible.
    if (
      selectedSport === AZ_BETTING &&
      selectedGameKey?.key !== "All" &&
      !favoritesFilterOn
    ) {
      return;
    }

    const games =
      selectedSport === LIVE_MOBIUS
        ? (Array.isArray(gameLiveData)
            ? gameLiveData.filter((item) =>
                updateStatus(item?.commence_time, item)
              )
            : [])
        : Array.isArray(gameLiveData)
          ? gameLiveData
          : [];

    const nextOptions = favoritesFilterOn
      ? filterLeagueOptionsForFavorites(
          buildLiveSportNavOptions(games),
          favGames,
          games
        )
      : buildLiveSportNavOptions(games);
    setoptions(nextOptions);

    if (
      selectedGameKey?.key !== "All" &&
      !isLiveSportTabValid(nextOptions, selectedGameKey)
    ) {
      setSelectedGameKey({ title: "All", key: "All" });
    }
  }, [
    selectedSport,
    gameLiveData,
    selectedGameKey?.key,
    favoritesFilterOn,
    favGames,
  ]);

  // const options2 = [
  //   { label: "All SPORTS | 18", value: "All SPORTS | 18" },
  //   { label: "NBA", value: "NBA" },
  //   { label: "NCCAB", value: "NCCAB" },
  //   { label: "NPB", value: "NPB" },
  //   { label: "KBO", value: "KBO" },
  //   { label: "MLB World Series Winner", value: "MLB World Series Winner" },
  //   { label: "NCCAB", value: "NCCAB" },
  // ];

  // const selectTeaser = (value, count) => { // always update input so typing works 
  // settotalTeaserBet(value); 
  // if (!count || count < 2) { toastAlert("error", "At least select two teams for a Teaser Bet"); return; } };

  const teaserSlip = CheckInd?.[0] || [];
  const teaserChartResult = resolveTeaserChartForLegs(teaserSlip);
  // Issue #6: only use resolved chart — never fall back to NFL for unknown/mixed sports.
  const teaserChartKey = teaserChartResult.ok ? teaserChartResult.chartKey : null;

  const calcTeaserPayout = (betAmount, teamCount, buyPoints = 6) => {
    if (!teaserChartKey) return 0;
    return roundMoney(
      calculateTeaserPayout(betAmount, teamCount, buyPoints, teaserChartKey)
    );
  };

  const supportedTeaserPoints = useMemo(
    () =>
      teaserChartKey
        ? getAllowedTeaserPoints(teaserChartKey, teaserSlip.length)
        : [],
    [teaserChartKey, teaserSlip.length]
  );

  useEffect(() => {
    if (betTabName === "Teaser" && CheckInd?.[0]?.length >= 2) {
      updateAllTeaserItems(totalTeaserBet, CheckInd[0].length, teaserPoints);
    }
  }, [betTabName, CheckInd?.[0]?.length]);

  useEffect(() => {
    if (betTabName !== "Teaser") return;
    if (supportedTeaserPoints.length > 0 && !supportedTeaserPoints.includes(teaserPoints)) {
      const nextTeaserPoints = supportedTeaserPoints[0];
      setTeaserPoints(nextTeaserPoints);
      if (CheckInd?.[0]?.length > 1) {
        updateAllTeaserItems(totalTeaserBet, CheckInd[0].length, nextTeaserPoints);
      }
    }
  }, [betTabName, supportedTeaserPoints, teaserPoints, CheckInd, totalTeaserBet]);



  const selectTeaser = (value, count, groupIdx = 0, itemIdx = 0) => {
    settotalTeaserBet(value);

    if (!count || count < 2) {
      toastAlert(
        "error",
        isDTS()
          ? `At least select two teams for a ${getEntryTypeLabel("Teaser", true)} ${getTerm("entry")}`
          : "At least select two teams for a Teaser Bet"
      );
      return;
    }

    setCheckInd((prev) => {
      const next = [...prev];
      const group = [...(next[groupIdx] || [])];
      const item = { ...(group[itemIdx] || {}) };

      const payout = calcTeaserPayout(
        Number(value) || 0,
        count,
        teaserPoints
      );

      // ✅ Calculate adjusted point
      const adjustedPoint = adjustTeaserLine(
        { ...item, buyPoints: teaserPoints },
        teaserPoints
      );

      console.log("item.pointType.teaser.pooints", item.point, teaserPoints, adjustedPoint, item);
      item.activatedTab = "teaser";
      item.Price = value;
      item.payout = payout;
      item.win = roundMoney(Number(payout) - Number(value));
      item.risk = value;
      item.buyPoints = teaserPoints;
      item.originalPoint = item.point;
      item.adjustedPoint = adjustedPoint;

      group[itemIdx] = item;
      next[groupIdx] = group;

      return next;
    });
  };

  const isboxChecked = (checkId, id) => {
    const slip = CheckInd?.[BET_SLIP_INDEX];
    if (!Array.isArray(slip)) return false;
    return slip.some(
      (item) => item.CheckId === checkId && item.id === id
    );
  };



  const updateAllTeaserItems = (betValue, teamCount, buyPoints) => {
    settotalTeaserBet(betValue);

    if (!teamCount || teamCount < 2) {
      toastAlert(
        "error",
        isDTS()
          ? `At least select two teams for a ${getEntryTypeLabel("Teaser", true)} ${getTerm("entry")}`
          : "At least select two teams for a Teaser Bet"
      );
      return;
    }

    setCheckInd((prev) => {
      const next = (Array.isArray(prev) ? prev : []).map((group) => {
        if (!Array.isArray(group)) return group;
        return group.map((item, itemIdx) => {
          if (item.type === "h2h") return item; // skip h2h

          const payout = calcTeaserPayout(
            Number(betValue) || 0,
            teamCount,
            buyPoints
          );

          const adjustedPoint = adjustTeaserLine(
            { ...item, buyPoints },
            buyPoints
          );

          console.log("teaserBuyPoints", buyPoints, adjustedPoint)
          return {
            ...item,
            activatedTab: "teaser",
            Price: betValue,
            payout,
            win: roundMoney(Number(payout) - Number(betValue)),
            risk: betValue,
            buyPoints,
            originalPoint: item.point,
            adjustedPoint,
          };
        });
      });

      return next;
    });
  };



  const americanBetCalc = (betAmount, odds) => {
    const bet = Number(betAmount);
    const o = Number(odds);

    if (!bet || !o) return { risk: 0, win: 0, payout: 0 };

    let win = 0;

    if (o > 0) {
      // Positive odds (e.g., +250 means you win 2.5x per 1 wager)
      win = (o / 100) * bet;
    } else {
      // Negative odds (e.g., -110 means you risk 110 to win 100)
      win = (100 / Math.abs(o)) * bet;
    }

    const payout = bet + win;

    return {
      risk: roundMoney(Math.abs(bet)),
      win: roundMoney(Math.abs(win)),
      payout: roundMoney(payout),
    };
  };
  const StraightamericanBetCalc = (amount, odds, mode = "risk") => {
    const bet = Number(amount);
    const o = Number(odds);

    if (!bet || !o) return { risk: "", win: "", payout: "" };

    let risk = 0;
    let win = 0;

    if (mode === "risk") {
      win = o > 0 ? (o / 100) * bet : (100 / Math.abs(o)) * bet;
      risk = bet;
    } else {
      risk = o > 0 ? (bet * 100) / o : (Math.abs(o) / 100) * bet;
      win = bet;
    }
    risk = Math.abs(risk);
    win = Math.abs(win);
    let payout = risk + win;

    return {
      risk: roundMoney(risk),
      win: roundMoney(win),
      payout: roundMoney(payout),
    };
  };


  const updateDesiredLine = (value, groupIdx, itemIdx) => {
    const sanitized = sanitizeDesiredLineInput(value);
    setCheckInd((prev) => {
      const next = [...prev];
      const group = [...(next[groupIdx] || [])];
      const item = { ...(group[itemIdx] || {}) };

      item.desiredPoint = sanitized;
      item.activatedTab = "straight";
      item.customizedPoint = item.originalPoint ?? item.point;
      item.point = item.originalPoint ?? item.point;
      item.buyPoints = 0;

      const validated = applyCallBetValidationToLeg(item);
      group[itemIdx] = validated;
      next[groupIdx] = group;
      return next;
    });
  };

  const updateDesiredPrice = (value, groupIdx, itemIdx) => {
    const sanitized = sanitizeDesiredOddsInput(value);
    setCheckInd((prev) => {
      const next = [...prev];
      const group = [...(next[groupIdx] || [])];
      const item = { ...(group[itemIdx] || {}) };

      item.desiredPrice = sanitized;
      item.activatedTab = "straight";
      item.buyPoints = 0;

      const validated = applyCallBetValidationToLeg(item);
      group[itemIdx] = recalculateCallBetPayout(validated);
      next[groupIdx] = group;
      return next;
    });
  };


  const straightpayOutCalc = (value, price, groupIdx, itemIdx, mode) => {
    const amount = Number(value) || 0;

    setCheckInd((prev) => {
      const next = [...prev];
      const group = [...(next[groupIdx] || [])];
      const item = { ...(group[itemIdx] || {}) };
      const payoutPrice = resolveCallBetPriceForPayout(item) ?? price;

      let risk = 0;
      let win = 0;
      let payout = 0;

      if (mode === "risk") {
        risk = amount;
        win = calcWinFromRisk(risk, payoutPrice);
      }

      if (mode === "win") {
        win = amount;
        risk = calcRiskFromWin(win, payoutPrice);
      }

      risk = roundMoney(risk);
      win = roundMoney(win);
      payout = roundMoney(risk + win);

      item.activatedTab = "straight";
      item.Price = risk;          // ✅ wager amount ONLY
      item.risk = risk;
      item.win = win;
      item.payout = payout;

      group[itemIdx] = item;
      next[groupIdx] = group;

      return next;
    });
  };

  const resetCheckInd = useCallback(() => {
    setCheckInd((prev) => {
      console.log("🌀 betTabName changed, resetting bets:", betTabName, prev);

      const next = Array.isArray(prev) ? [...prev] : [];

      const updated = next.map((group) => {
        if (Array.isArray(group)) {
          return group.map((item) => ({
            ...item,
            activatedTab: "",
            Price: "",
            risk: "",
            win: "",
            payout: "",
          }));
        }

        return {
          ...group,
          activatedTab: "",
          Price: "",
          risk: "",
          win: "",
          payout: "",
        };
      });

      // ⚠️ Only update if there's an actual change
      const hasChanges = JSON.stringify(prev) !== JSON.stringify(updated);
      return hasChanges ? updated : prev;
    });
  }, [betTabName, selectedSport]);

  useEffect(() => {
    resetCheckInd();
  }, [resetCheckInd]);



  const payOutCalc = (value, price, groupIdx, itemIdx) => {
    console.log("payOutCalc", value, price, groupIdx, itemIdx)
    const bet = Number(value) || 0;

    setCheckInd((prev) => {
      const next = [...prev];
      const group = [...(next[groupIdx] || [])];

      // update only the edited bet
      const item = { ...(group[itemIdx] || {}) };
      const { risk, win, payout } = StraightamericanBetCalc(bet, price);

      item.Price = bet;
      item.risk = risk;
      item.win = win;
      item.payout = payout;

      group[itemIdx] = item;
      next[groupIdx] = group;

      // 🔹 Recalculate totals for all bets in this group
      let totalRisk = 0,
        totalWin = 0,
        totalPayout = 0;
      for (let i = 0; i < group.length; i++) {
        totalRisk += Number(group[i].risk || 0);
        totalWin += Number(group[i].win || 0);
        totalPayout += Number(group[i].payout || 0);
      }

      return next;
    });
  };



  // const handleParlayChange = (value) => {
  //   const bet = Number(value) || 0;
  //   setTotalBet(value);
  //   console.log(totalBet, "totalBettotalBettotalBet");
  //   setCheckInd((prev) => {
  //     const next = [...prev];
  //     const group = [...(next[0] || [])];

  //     // update payout for all bets
  //     const updatedGroup = group.map((item) => {
  //       console.log("updatedGroupitemitemitem", item);
  //       const { risk, win, payout } = americanBetCalc(bet, item.price);
  //       setparlyPayout(payout)
  //       return { ...item, Price: bet, risk, win, payout };
  //     });


  //     next[0] = updatedGroup;
  //     return next;
  //   });
  // };


  // const [parleyMultiplier, setParleyMultiplier] = useState(1);

  const handleParlayChange = (value) => {
    const sanitized = String(value ?? "").replace(/[^\d.]/g, "");
    if (sanitized.length > MAX_BET_DIGITS + 3) return;
    const numeric = Number(sanitized);
    if (Number.isFinite(numeric) && numeric > MAX_BET_AMOUNT) return;
    const bet = Number.isFinite(numeric) ? numeric : 0;
    setTotalBet(sanitized === "" ? "" : bet);

    setCheckInd((prev) => {
      const next = [...prev];
      const group = [...(next[0] || [])];

      if (!group.length) return next;

      const legPrices = getLegPricesFromSelections(group);
      if (legPrices.length !== group.length) {
        setparlyPayout(0);
        next[0] = group;
        return next;
      }

      const { win: parleyWin, payout } = calcParlayPayout(bet, legPrices);

      const updatedGroup = group.map((item) => ({
        ...item,
        activatedTab: "parlay",
        risk: roundMoney(bet),
        Price: roundMoney(bet),
        win: roundMoney(parleyWin),
        payout: roundMoney(payout),
      }));

      setparlyPayout(roundMoney(payout));
      next[0] = updatedGroup;
      return next;
    });
  };

  useEffect(() => {
    if (betTabName !== "Parlay Bet") return;
    if (totalBet === "" || totalBet === null || totalBet === undefined) return;
    const bet = Number(totalBet);
    if (!Number.isFinite(bet) || bet <= 0) return;
    handleParlayChange(String(totalBet));
    // Recalc when legs/odds change; stake changes already call handleParlayChange.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [parlayLegPriceKey, betTabName]);


  const handlePoints = (value, index, ind) => {
    const nextSlip = [...CheckInd];
    const row = { ...(nextSlip[ind][index] || {}) };
    const base = Number(row.originalPoint ?? row.point);

    row.point = value.point;
    row.price = value.price;
    row.payout = roundMoney(
      parseFloat(row.risk || 0) + parseFloat(row.win || 0)
    );
    row.customizedPoint = value.point;
    row.isCallBetType = "false";
    row.desiredPoint = "";
    row.desiredPrice = "";

    if (Number.isFinite(base) && Number.isFinite(Number(value.point))) {
      row.buyPoints =
        Math.round(Math.abs(Number(value.point) - base) * 100) / 100;
    } else {
      row.buyPoints = 0;
    }

    nextSlip[ind][index] = row;
    setCheckInd(nextSlip);
    setBetPrice(value.price);
    setBetPoint(value.point);
  };

  console.log("ticketArr_Det", ticketArr);


  const handleChangeOnClickGame = (e, item, market, i, index, outcomeIndex) => {
    if (
      e.target.checked &&
      !isGameOpenForBetting(item?.commence_time, item)
    ) {
      e.target.checked = false;
      toastAlert("error", endedMatchSelectionMessage(), "match-ended");
      return;
    }

    if (e.target.checked && betTabName === "Teaser" && market?.key === "h2h") {
      e.target.checked = false;
      toastAlert("error", teaserMoneylineSelectionsMessage());
      return;
    }

    const outcome = market?.outcomes?.[outcomeIndex];
    // Record the bookmaker whose odds are actually displayed/selected (index `i`),
    // not bookmakers[0]. Call-bet activation re-reads odds from this key
    // (see backend getMarketOutcomeForCallBet), so it must match the shown book.
    const itemBookMark =
      item?.bookmakers?.[i]?.key ?? item?.bookmakers?.[0]?.key;
    const checkId = `${item.id}-${i}-${index}-${outcomeIndex}`;
    const totalsSide = String(outcome?.name || "").toLowerCase();
    const selectionTeamName =
      market?.key === "totals"
        ? totalsSide === "over"
          ? item.home_team
          : totalsSide === "under"
            ? item.away_team
            : outcome?.name
        : outcome?.name;

    const teamObj = {
      teamName: selectionTeamName,
      homeTeam: item.home_team,
      awayTeam: item.away_team,
      type: market?.key,
      price: outcome?.price ?? "-",
      point: outcome?.point ?? "-",
      pointType: market?.key === "totals" ? outcome?.name : "",
      bookMarkType: itemBookMark,
      sport_key: item.sport_key,
      sport_title: item.sport_title,
      gameTime: item.commence_time,
      id: item.id,
      CheckId: checkId,
    };

    if (e.target.checked) {
      pushToRecentGames(item);
    }

    teamsSelect(e, teamObj);
  };


  // const validateOnClick=(markets,key)=>{
  //   let flag=false;
  //   for(let i=0;i<markets.length;i++){
  //     if(markets.keys==key)
  //   }
  // }

  const handleLikeButton = async (item) => {
    if (!islogeedin) {
      history.push("/login");
      return;
    }
    if (!item?.id) return;

    // Snapshot current state so we can revert if the API call fails.
    const prevFavGames = favGames;
    const isCurrentlyFav = prevFavGames.some((g) => g.id === item.id);

    // 1) Optimistically update UI so the star changes instantly.
    const nextFavGames = isCurrentlyFav
      ? prevFavGames.filter((g) => g.id !== item.id)
      : [...prevFavGames, item];
    setFavGames(nextFavGames);

    // 2) Give the user immediate, deduped toast feedback.
    toastAlert(
      "success",
      isCurrentlyFav ? "Removed from Favorites" : "Added to Favorites",
      "favorite-toggle"
    );

    // 3) Persist to backend; revert on failure so UI stays truthful.
    try {
      const response = await setFavsport(item);
      if (!response?.status) {
        setFavGames(prevFavGames);
        toastAlert(
          "error",
          response?.message || "Unable to update favorite. Please try again.",
          "favorite-toggle"
        );
      }
    } catch (err) {
      console.log("handleLikeButton error", err);
      setFavGames(prevFavGames);
      toastAlert(
        "error",
        "Unable to update favorite. Please try again.",
        "favorite-toggle"
      );
    }
  };
  const [recentGames, setRecentGames] = useState(() =>
    loadRecentGamesFromStorage()
  )

  const pushToRecentGames = (game) => {
    if (!game?.id) return
    setRecentGames((prev) => {
      const next = addRecentGame(prev, game)
      saveRecentGamesToStorage(next)
      return next
    })
  }

  const handleClearAllRecents = () => {
    setRecentGames([])
    saveRecentGamesToStorage([])
  }

  const handleRemoveRecentGame = (game) => {
    if (!game?.id) return
    setRecentGames((prev) => {
      const next = removeRecentGame(prev, game.id)
      saveRecentGamesToStorage(next)
      return next
    })
  }

  const favSportFetch = async () => {
    const fetchedData = await getFavsport()
    const favorites = Array.isArray(fetchedData?.result) ? fetchedData.result : []
    setFavGames(favorites)
  }
  useEffect(() => {
    favSportFetch()
  }, [])

  useEffect(() => {
    setRecentGames((prev) => {
      const hydrated = hydrateRecentGames(prev, gameLiveData)
      if (hydrated.length !== prev.length) {
        saveRecentGamesToStorage(hydrated)
        return hydrated
      }
      const changed = hydrated.some(
        (game, index) => game !== prev[index] || game.id !== prev[index]?.id
      )
      if (changed) {
        saveRecentGamesToStorage(hydrated)
        return hydrated
      }
      return prev
    })
  }, [gameLiveData])

  const { favorites: sidebarFavorites, recents: sidebarRecents } = useMemo(
    () => partitionFavoritesRecents(favGames, recentGames),
    [favGames, recentGames]
  )

  const [bookmakerOptions, setBookMarkOption] = useState([]);
  // const [selectedbookMarkOption, setSelectedbookMarkOption] = useState(null);
  const [filteredGameData, setFilteredGameData] = useState([]);

  // Prepare bookmaker options
  const optionset = useCallback(() => {
    if (!Array.isArray(gameLiveData) || gameLiveData.length === 0) return;


    const allKeys = gameLiveData.flatMap(game =>
      (game.bookmakers || []).map(b => b.key)
    );

    const uniqueKeys = [...new Set(allKeys)];

    const sortedKeys = uniqueKeys.sort((a, b) => {
      if (a.toLowerCase() === "draftkings") return -1;
      if (b.toLowerCase() === "draftkings") return 1;
      return 0;
    });

    const bookMarkOption = sortedKeys.map(key => ({
      value: key,
      label: key.charAt(0).toUpperCase() + key.slice(1) // ✅ Capitalize first letter
    }));

  }, [gameLiveData, selectedSport]);

  useEffect(() => {
    optionset();
  }, [optionset]);


  const renderGameCard = (item, index) => {
    const userFavGames = favGames.map((g) => g.id);
    const bookmaker = getPreferredBookmaker(item?.bookmakers);
    if (!bookmaker) return null;
    const bookmakerIndex = Math.max(
      0,
      (item?.bookmakers || []).findIndex((b) => b.key === bookmaker.key)
    );
    const h2hMarket = bookmaker.markets.find((m) => m.key === "h2h");
    const h2hSides = h2hMarket
      ? resolveH2hSides(h2hMarket, item.home_team, item.away_team)
      : null;
    // Featured board columns are spreads / h2h / totals. Playable extras are
    // alternate_spreads / alternate_totals. Board cache usually only has
    // featured keys; when an enriched count is present, honour it and hide
    // the control when known-empty. Otherwise show bare "+ More" (no fake 0).
    const PLAYABLE_EXTRA_KEYS = new Set([
      "alternate_spreads",
      "alternate_totals",
    ]);
    const cachedExtraCount = (bookmaker.markets || []).filter((m) =>
      PLAYABLE_EXTRA_KEYS.has(m?.key)
    ).length;
    const enrichedCount = Number.isFinite(Number(item.extraMarketCount))
      ? Number(item.extraMarketCount)
      : null;
    const moreMarketCount =
      enrichedCount != null ? enrichedCount : cachedExtraCount;
    const showMoreMarketsButton =
      enrichedCount != null ? moreMarketCount > 0 : true;

    const renderH2hCheckbox = (outcomeIndex, drawLabel = null) => {
      if (!h2hMarket || outcomeIndex < 0) return <p>-</p>;
      const marketIndex = bookmaker.markets.indexOf(h2hMarket);
      const outcome = h2hMarket.outcomes[outcomeIndex];
      return (
        <label>
          <input
            type="checkbox"
            checked={isboxChecked(
              `${item.id}-${bookmakerIndex}-${marketIndex}-${outcomeIndex}`,
              item.id
            )}
            onChange={(e) =>
              handleChangeOnClickGame(
                e,
                item,
                h2hMarket,
                bookmakerIndex,
                marketIndex,
                outcomeIndex
              )
            }
          />
          {drawLabel ? <h3 className="fs13">{drawLabel}</h3> : null}
          <h3 className={drawLabel ? "fs15" : "fs13"}>
            {formatOdds(outcome?.price)}
          </h3>
        </label>
      );
    };

    return (
      <div
        key={item.id || `game-${index}`}
        id={item.id ? getGameCardElementId(item.id) : undefined}
        className={[
          "game-card-item",
          highlightedGameId === item.id ? "game-card-item--highlighted" : "",
        ]
          .filter(Boolean)
          .join(" ")}
      >
        <div className="bodyDetailsPart">
          <div className="detailTopPart">
            <div className="leftPart">
              <button
                type="button"
                className="starBtn"
                aria-label={
                  userFavGames.includes(item.id)
                    ? "Remove from favorites"
                    : "Add to favorites"
                }
                onClick={() => handleLikeButton(item)}
              >
                <IoStar
                  className="icon"
                  fill={userFavGames.includes(item.id) ? "#FFDA00" : "gray"}
                />
              </button>
            </div>
          </div>

          <div className="detailsMiddlePart" key={bookmaker.key || bookmakerIndex}>
              <div className="content1">
                {/* Phone: star in the far-left corner, same row as Spread / M-Line / Total. */}
                <button
                  type="button"
                  className="starBtn game-card-meta__star game-card-meta__star--labels"
                  aria-label={
                    userFavGames.includes(item.id)
                      ? "Remove from favorites"
                      : "Add to favorites"
                  }
                  onClick={() => handleLikeButton(item)}
                >
                  <IoStar
                    className="icon"
                    fill={userFavGames.includes(item.id) ? "#FFDA00" : "gray"}
                  />
                </button>
                <div className="headingContent d-flex align-items-center gap-3">
                  <TeamLogo teamName={item?.home_team} logoUrl={item?.home_team_logo} size="md" alt={item?.home_team} />
                  <p className="fs15 teamNameText">{item?.home_team}</p>
                </div>
                <p className="fs14 py-1 px-2">vs</p>
                <div className="headingContent d-flex align-items-center gap-3">
                  <TeamLogo teamName={item?.away_team} logoUrl={item?.away_team_logo} size="md" alt={item?.away_team} />
                  <p className="fs15 teamNameText">{item?.away_team}</p>
                </div>
                {/* Same date markup/classes as before — under teams so gap stays tight. */}
                <div className="dateCardTemplate">
                  <GameDateDisplay dateTime={item?.commence_time} />
                </div>
              </div>

              <div className="content2">
                <div className="tvBgImg">
                  <div className="tvStatusBadge">
                    <MatchStatus matchTime={item?.commence_time} game={item} />
                  </div>
                  <div className="game-card-live-score">
                    <MatchLiveScorePanel
                      game={item}
                      phase={UpcomingStatus(item?.commence_time, item)}
                    />
                  </div>
                </div>
              </div>

              <div className="content3">
                <div className="headingTextPart">
                  <ul className="d-flex align-items-center justify-content-between gap-2 m-0">
                    <li className="fs13">Spread</li>
                    <li className="fs13">{getFeaturedMarketLabel("h2h", isDTS())}</li>
                    <li className="fs13">Total</li>
                  </ul>
                </div>

                <ul className="pointUlTag">
                  <li>
                    {bookmaker.markets.find((m) => m.key === "spreads") ? (
                      (() => {
                        const m = bookmaker.markets.find((m) => m.key === "spreads");
                        const idx = m.outcomes.findIndex((o) => o.name === item.home_team);
                        return idx !== -1 ? (
                          <label>
                            <input
                              type="checkbox"
                              checked={isboxChecked(`${item.id}-${bookmakerIndex}-${bookmaker.markets.indexOf(m)}-${idx}`, item.id)}
                              onChange={(e) => handleChangeOnClickGame(e, item, m, bookmakerIndex, bookmaker.markets.indexOf(m), idx)}
                            />
                            <h3 className="fs13">{formatPoint(m.outcomes[idx].point)}</h3>
                            <p className="fs15">{formatOdds(m.outcomes[idx].price)}</p>
                          </label>
                        ) : <p>-</p>;
                      })()
                    ) : <p>-</p>}
                  </li>

                  <li className="inputCheckboxWrapper">
                    {h2hMarket ? (
                      renderH2hCheckbox(h2hSides?.home?.index ?? -1)
                    ) : (
                      <p>-</p>
                    )}
                  </li>

                  <li>
                    {bookmaker.markets.find((m) => m.key === "totals") ? (
                      (() => {
                        const m = bookmaker.markets.find((m) => m.key === "totals");
                        const idx = m.outcomes.findIndex((o) => o.name === "Over");
                        return idx !== -1 ? (
                          <label>
                            <input
                              type="checkbox"
                              checked={isboxChecked(`${item.id}-${bookmakerIndex}-${bookmaker.markets.indexOf(m)}-${idx}`, item.id)}
                              onChange={(e) => handleChangeOnClickGame(e, item, m, bookmakerIndex, bookmaker.markets.indexOf(m), idx)}
                            />
                            <h3 className="fs13">
                              {formatTotalPoint(m.outcomes[idx].point, "Over")}
                            </h3>
                            <p className="fs15">{formatOdds(m.outcomes[idx].price)}</p>
                          </label>
                        ) : <p>-</p>;
                      })()
                    ) : <p>-</p>}
                  </li>
                </ul>

                {h2hSides?.isThreeWay ? (
                  <ul className="pointUlTag pointUlTag--draw">
                    <li>
                      <p>-</p>
                    </li>
                    <li className="inputCheckboxWrapper">
                      {renderH2hCheckbox(
                        h2hSides.draw.index,
                        getDrawDisplayLabel(h2hSides.draw.outcome?.name)
                      )}
                    </li>
                    <li>
                      <p>-</p>
                    </li>
                  </ul>
                ) : null}

                <ul className="pointUlTag">
                  <li>
                    {bookmaker.markets.find((m) => m.key === "spreads") ? (
                      (() => {
                        const m = bookmaker.markets.find((m) => m.key === "spreads");
                        const idx = m.outcomes.findIndex((o) => o.name === item.away_team);
                        return idx !== -1 ? (
                          <label>
                            <input
                              type="checkbox"
                              checked={isboxChecked(`${item.id}-${bookmakerIndex}-${bookmaker.markets.indexOf(m)}-${idx}`, item.id)}
                              onChange={(e) => handleChangeOnClickGame(e, item, m, bookmakerIndex, bookmaker.markets.indexOf(m), idx)}
                            />
                            <h3 className="fs15">{formatPoint(m.outcomes[idx].point)}</h3>
                            <p className="fs13">{formatOdds(m.outcomes[idx].price)}</p>
                          </label>
                        ) : <p>-</p>;
                      })()
                    ) : <p>-</p>}
                  </li>

                  <li>
                    {h2hMarket ? (
                      renderH2hCheckbox(h2hSides?.away?.index ?? -1)
                    ) : (
                      <p>-</p>
                    )}
                  </li>

                  <li>
                    {bookmaker.markets.find((m) => m.key === "totals") ? (
                      (() => {
                        const m = bookmaker.markets.find((m) => m.key === "totals");
                        const idx = m.outcomes.findIndex((o) => o.name === "Under");
                        return idx !== -1 ? (
                          <label>
                            <input
                              type="checkbox"
                              checked={isboxChecked(`${item.id}-${bookmakerIndex}-${bookmaker.markets.indexOf(m)}-${idx}`, item.id)}
                              onChange={(e) => handleChangeOnClickGame(e, item, m, bookmakerIndex, bookmaker.markets.indexOf(m), idx)}
                            />
                            <h3 className="fs13">
                              {formatTotalPoint(m.outcomes[idx].point, "Under")}
                            </h3>
                            <p className="fs15">{formatOdds(m.outcomes[idx].price)}</p>
                          </label>
                        ) : <p>-</p>;
                      })()
                    ) : <p>-</p>}
                  </li>
                </ul>

                {showMoreMarketsButton && (
                  <div className="game-card-meta__actions game-card-meta__actions--under-total">
                    <button
                      type="button"
                      className="game-card-meta__more"
                      aria-label={
                        moreMarketCount > 0
                          ? `Plus more markets, ${moreMarketCount}`
                          : "More markets for this event"
                      }
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        showFullDetailHandle(item);
                      }}
                    >
                      {moreMarketCount > 0
                        ? `+ More (${moreMarketCount})`
                        : "+ More"}
                    </button>
                  </div>
                )}
              </div>

              {/* Phone: time bottom-left + compact live/final score (TV hidden in phone-shell CSS). */}
              <div className="game-card-meta game-card-meta--footer">
                <GameDateDisplay dateTime={item?.commence_time} tzAs="span" />
                <div className="game-card-mobile-score">
                  <MatchLiveScorePanel
                    game={item}
                    phase={UpcomingStatus(item?.commence_time, item)}
                    variant="compact"
                  />
                </div>
              </div>
            </div>
        </div>
      </div>
    );
  };

  const renderSportCategoryGroup = ({ sportTitle, entries }) => {
    const categoryId = getSportCategoryId(sportTitle);
    const gameCards = entries
      .map(({ item, index }) => renderGameCard(item, index))
      .filter(Boolean);

    if (gameCards.length === 0) return null;

    const categoryIconUrl = resolveSportIconUrl(sportTitle, sportIconMaps);

    return (
      <CustomAccordionItem
        key={categoryId}
        id={categoryId}
        className="sport-category-group"
      >
        <CustomAccordionHeader
          className="sport-category-header"
          toggleStyle="plus-minus"
        >
          <div className="sport-category-header__content">
            <SportIcon
              sportName={sportTitle}
              iconUrl={categoryIconUrl}
              alt={sportTitle}
              size={28}
            />
            <div className="sport-category-header__text">
              <p className="m-0 fs14 fw-500">{sportTitle}</p>
              <span className="fs12 mg-text-gray1">
                {gameCards.length} {gameCards.length === 1 ? "Event" : "Events"}
              </span>
            </div>
          </div>
        </CustomAccordionHeader>
        <CustomAccordionBody className="sport-category-body">
          <div className="sport-category-body__inner">
            {gameCards}
          </div>
        </CustomAccordionBody>
      </CustomAccordionItem>
    );
  };

  const fetchOddsDetails = async (data) => {
    const contextKey = buildOddsFeedContextKey(
      selectedSport,
      data?.sport_key?.[0]?.key || "All"
    );
    const requestId = beginOddsFeedFetch(contextKey);
    setInitialLoading(true);
    try {
      let { status, result, meta } = await getOddsList(data, dispatch);
      if (requestId !== requestIdRef.current) {
        return;
      }
      applyOddsFeedResult(requestId, status === true ? result : [], meta);
      await favSportFetch();
    } catch (err) {
      if (requestId !== requestIdRef.current) {
        return;
      }
      console.log("fetchOddsDetails err", err);
      setHasMore(false);
    } finally {
      if (requestId === requestIdRef.current) {
        setInitialLoading(false);
      }
    }
  };
  // /get-live-Odds-List
  const fetchLiveOddsDetails = async () => {
    const contextKey = buildOddsFeedContextKey("livemobius", "live");
    const requestId = beginOddsFeedFetch(contextKey);
    setInitialLoading(true);
    try {
      let { status, message, result } = await getLiveOddsList();
      if (requestId !== requestIdRef.current) {
        return;
      }
      const games = status == true ? normalizeGames(result) : [];
      setLiveGame(games);
      applyOddsFeedResult(requestId, games, { hasMore: false });
      await favSportFetch();
    } catch (err) {
      if (requestId !== requestIdRef.current) {
        return;
      }
      console.log("err", err);
      setLiveGame([]);
      setHasMore(false);
    } finally {
      if (requestId === requestIdRef.current) {
        setInitialLoading(false);
      }
    }
  };

  /**
   * HTTP fallback for live scores (socket primary via useLiveBoardSocket).
   * Sync on reconnect, tab focus, and a long interval if events are missed.
   */
  useEffect(() => {
    let cancelled = false;

    const refreshLiveScoresSilent = async () => {
      if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        return;
      }
      try {
        const { status, result } = await getLiveOddsList();
        if (cancelled || status !== true) return;
        if (selectedSport === LIVE_MOBIUS) {
          const liveGames = normalizeGames(result);
          setLiveGame(liveGames);
          setGameLiveData(liveGames);
          setSelectedTeam((prev) => mergeLiveFieldsIntoGame(prev, liveGames));
        } else {
          applyLiveScoreGames(result);
        }
      } catch (err) {
        console.log("silent live score refresh err", err);
      }
    };

    const intervalId = setInterval(
      refreshLiveScoresSilent,
      LIVE_BOARD_SCORE_FALLBACK_MS
    );
    const onVisibility = () => {
      if (document.visibilityState === "visible") {
        refreshLiveScoresSilent();
      }
    };
    const onSocketConnect = () => {
      refreshLiveScoresSilent();
    };

    document.addEventListener("visibilitychange", onVisibility);
    socket?.on("connect", onSocketConnect);

    return () => {
      cancelled = true;
      clearInterval(intervalId);
      document.removeEventListener("visibilitychange", onVisibility);
      socket?.off("connect", onSocketConnect);
    };
  }, [selectedSport, socket, applyLiveScoreGames]);

  //useEffect
  useEffect(() => {
    if (isMongoObjectId(id)) {
      getOpenSpotDetails();
    }
  }, [id]);
  useEffect(() => {
    fetchGameDatasFetchCall();
  }, []);

  useEffect(() => {
    if (allGameType) {
      const gameType = allGameType[0]?._id;
      if (gameType) {
        fetchGameDataFetchCall(gameType);
      }
    }
  }, [allGameType]);




  useEffect(() => {
    console.log("ticket>>>>>>>>>", CheckInd);

    if (accountData) {
      fetchWalletData();
    }
  }, [accountData]);
  useEffect(() => {
    if (isChecked) {
      // handleselect(options[0]);
    }
  }, [isChecked, CheckInd]);

  useEffect(() => {


    const { bet } = (Array.isArray(CheckInd) ? CheckInd.flat() : [])
      .reduce(
        (acc, item) => {
          acc.bet += Number(item?.Price) || 0;
          return acc;
        },
        { bet: 0 }
      );


    settotalbetamount(roundMoney(bet));
  }, [CheckInd]);

  const [page, setPage] = useState(1)
  const fetchPage = useCallback(async () => {
    if (loading || initialLoading || !hasMore) return;

    const requestId = pageRequestIdRef.current;
    setLoading(true);

    const data = { "SelectedSport": selectedSport, "SelectedGameSport": [selectedGameKey] }
    try {
      const newData = await getOddsListnextItems(data, page);
      if (requestId !== pageRequestIdRef.current) {
        return;
      }
      const nextGames = normalizeGames(newData?.result);
      if (nextGames.length > 0) {
        let addedCount = 0;
        setGameLiveData((prev) => {
          const merged = appendUniqueOddsGames(prev, nextGames);
          addedCount = merged.length - prev.length;
          return merged;
        });
        if (addedCount > 0) {
          setHasMore(computeHasMoreFromMeta(newData?.meta, nextGames.length));
          const nextPage =
            newData?.meta?.hasMore && Number.isFinite(Number(newData?.meta?.page))
              ? Number(newData.meta.page) + 1
              : page + 1;
          setPage(nextPage);
        } else {
          setHasMore(false);
        }
      } else {
        setHasMore(computeHasMoreFromMeta(newData?.meta, 0));
      }
    } catch (err) {
      if (requestId !== pageRequestIdRef.current) {
        return;
      }
      console.log("fetchPage err", err);
      setHasMore(false);
    } finally {
      if (requestId === pageRequestIdRef.current) {
        setLoading(false);
      }
    }
  }, [page, selectedSport, selectedGameKey, hasMore, loading, initialLoading]);




  useEffect(() => {
    if (tabCount !== 1 || isMobileStacked) return undefined;

    const el = straightBetListScrollRef.current;
    if (!el) return undefined;

    const handleScroll = () => {
      if (el.scrollTop < 40) return;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 100) {
        fetchPage();
      }
    };

    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => el.removeEventListener("scroll", handleScroll);
  }, [fetchPage, tabCount, isMobileStacked]);

  const MAX_BET_DIGITS = 7;
  const MAX_BET_AMOUNT = 1000000;

  const handleNumberInput = (value, callback) => {
    if (!/^\d*$/.test(value)) return;
    if (value.length > MAX_BET_DIGITS) return;
    if (value !== "" && Number(value) > MAX_BET_AMOUNT) return;
    callback(value);
  };


  const [selectedOption, setSelectedOption] = useState([{ tittle: "All", key: "All" }]);
  // useEffect(() => {
  //   const fetchData = async () => {
  //     const data = {
  //       sport_key: [selectedOption]
  //     };
  //     console.log("sending data:", selectedOption);
  //     if (selectedOption.title == "All") {
  //       console.log("alldatatata", gameList)
  //       const gameData = await fetchGameDataforCategory(selectedSport);
  //     } else {
  //       let { status, message, result } = await getOddsList(data, dispatch);
  //       setGameLiveData(result)
  //     }
  //   };

  //   if (selectedOption) {
  //     fetchData();
  //   }
  // }, [selectedOption]);

  // Function to fetch game or odds data based on selectedOption

  const fetchDataForSelectedOption = async (selectedOption, selectedSport) => {
    setPage(1);
    setMobileVisibleCount(MOBILE_MATCHES_INITIAL);

    if (selectedSport === LIVE_MOBIUS) {
      setSelectedGameKey(
        selectedOption?.title === "All"
          ? { tittle: "All", key: "All" }
          : selectedOption
      );
      return;
    }

    // Favorites league chips only filter the already-loaded all-sports feed.
    // Refetching a single league would replace that feed and mark other stars
    // unavailable. "All" still refetches — needed when entering Favorites after
    // an A-Z single-league filter left a narrowed gameLiveData.
    if (favoritesFilterOn) {
      const leagueKey =
        selectedOption?.key || selectedOption?.title || selectedOption?.tittle;
      if (leagueKey && leagueKey !== "All") {
        setSelectedGameKey(selectedOption);
        return;
      }
    }

    const leagueKey = selectedOption?.key || selectedOption?.title || "All";
    const contextKey = buildOddsFeedContextKey(selectedSport, leagueKey);
    const requestId = beginOddsFeedFetch(contextKey, {
      keepExisting: favoritesFilterOn,
    });
    setInitialLoading(true);
    try {
      if (!selectedOption) return;

      if (selectedOption.title === "All") {
        setSelectedGameKey({ tittle: "All", key: "All" });
        if (selectedSport === AZ_BETTING) {
          const data = {
            sport_key: [{ title: AZ_BETTING, key: AZ_BETTING }],
          };
          const { status, result, meta } = await getOddsList(data, dispatch);
          if (requestId !== requestIdRef.current) {
            return;
          }
          applyOddsFeedResult(requestId, status === true ? result : [], meta);
        } else {
          await fetchAlloptionForSelectedGames(requestId);
        }
      } else {
        setSelectedGameKey(selectedOption)
        // A single league filter (e.g. NFL) also shows every one of its events
        // in one response (all: true) rather than the first 50 + scroll.
        const data = { sport_key: [selectedOption], all: true };
        console.log("Fetching odds data with payload:", data);
        const { status, result, meta } = await getOddsList(data, dispatch);
        if (requestId !== requestIdRef.current) {
          return;
        }
        applyOddsFeedResult(requestId, status === true ? result : [], meta);
      }
    } catch (err) {
      if (requestId !== requestIdRef.current) {
        return;
      }
      console.error("Error fetching data:", err);
      setHasMore(false);
    } finally {
      if (requestId === requestIdRef.current) {
        setInitialLoading(false);
      }
    }
  };


  useEffect(() => {
    const leagueKey = location.state?.selectedLeagueKey;
    if (!leagueKey || !isSportGroup(selectedSport)) return;
    const token = `${selectedSport}:${leagueKey}`;
    if (appliedLeagueRef.current === token) return;
    const match = options.find((option) => option?.key === leagueKey);
    if (!match) return;
    appliedLeagueRef.current = token;
    fetchDataForSelectedOption(match, selectedSport);
  }, [location.state, options, selectedSport]);

  // Favorites filter enter/leave.
  // Enter: Favorites always joins stars to the full all-sports feed. If A-Z was
  // on a single league chip, gameLiveData is narrowed — without a full reload,
  // stars outside that league would look missing from the board.
  // Leave: reset league chip + reload so A-Z does not keep the Favorites chip.
  useEffect(() => {
    const wasFavorites = wasFavoritesFilterRef.current;
    wasFavoritesFilterRef.current = favoritesFilterOn;

    if (favoritesFilterOn) {
      if (!wasFavorites) {
        setSelectedTeam(undefined);
        setTabCount(1);
        fetchDataForSelectedOption({ title: "All", key: "All" }, AZ_BETTING);
      }
      return;
    }

    if (!wasFavorites) return;

    setSelectedTeam(undefined);
    setTabCount(1);
    fetchDataForSelectedOption({ title: "All", key: "All" }, selectedSport);
    // Intentionally only when the favorites filter toggles.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [favoritesFilterOn]);

  const favoritesLeagueIsAll = isFavoritesLeagueAll(selectedGameKey);

  const getFilteredGameLiveData = useCallback(() => {
    if (!Array.isArray(gameLiveData)) return [];
    const source = selectedSport === LIVE_MOBIUS
      ? filterLiveGamesBySportTab(
          gameLiveData.filter((item) =>
            updateStatus(item?.commence_time, item)
          ),
          selectedGameKey
        )
      : gameLiveData;
    const queried = filterGamesByTeamQuery(source, boardQuery);
    if (!favoritesFilterOn) return queried;

    // Favorites is a board filter: only starred matches still on the live
    // odds feed (upcoming / live). Ended or delisted stars stay in the DB
    // but are not listed here.
    const { playable } = partitionFavoriteBoardGames(favGames, queried);
    const leagueKey = selectedGameKey?.key || selectedGameKey?.title || "All";
    return filterFavoriteGamesByLeague(playable, leagueKey);
  }, [
    gameLiveData,
    selectedSport,
    selectedGameKey,
    boardQuery,
    favoritesFilterOn,
    favGames,
  ]);

  const favoritesEmptyCopy = useMemo(() => {
    if (!favoritesFilterOn) {
      return {
        title: "Currently No Data Found",
        detail: "",
      };
    }
    if (!favoritesLeagueIsAll) {
      const leagueName =
        selectedGameKey?.title ||
        selectedGameKey?.tittle ||
        selectedGameKey?.key ||
        "this league";
      return {
        title: `No favorites in ${leagueName}`,
        detail: "Choose All to see every open starred match, or star a game in this league.",
      };
    }
    if (!favGames.length) {
      return {
        title: "No favorites yet",
        detail: "Tap the star on any match to save it here.",
      };
    }
    return {
      title: "No open favorites",
      detail: "Starred matches show here when they are upcoming or live.",
    };
  }, [
    favoritesFilterOn,
    favGames.length,
    favoritesLeagueIsAll,
    selectedGameKey,
  ]);

  const handleFavRecentGameSelect = useCallback(
    (item) => {
      if (!item?.id) return;

      const dataToRender = getFilteredGameLiveData();
      const gameIndex = findGameIndexInList(dataToRender, item.id);

      if (gameIndex === -1) {
        toastAlert(
          "info",
          isDTS()
            ? `This match is not in the current list. Open A-Z ${getTerm("play")} to browse all sports.`
            : "This match is not in the current list. Open A-Z Betting to browse all sports."
        );
        return;
      }

      if (tabCount !== 1) {
        setTabCount(1);
      }

      if (isMobileStacked && gameIndex >= mobileVisibleCount) {
        setMobileVisibleCount(gameIndex + 1);
      }

      setHighlightedGameId(item.id);
    },
    [
      getFilteredGameLiveData,
      tabCount,
      isMobileStacked,
      mobileVisibleCount,
    ]
  );

  useEffect(() => {
    if (!highlightedGameId || tabCount !== 1) return undefined;

    const scrollTimer = setTimeout(() => {
      const el = document.getElementById(getGameCardElementId(highlightedGameId));
      el?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 80);

    const clearTimer = setTimeout(() => setHighlightedGameId(null), 3000);

    return () => {
      clearTimeout(scrollTimer);
      clearTimeout(clearTimer);
    };
  }, [highlightedGameId, tabCount, mobileVisibleCount]);

  const filteredGameCount = getFilteredGameLiveData().length;

  const expandedAccordionIds = useMemo(() => {
    const dataToRender = getFilteredGameLiveData();
    const visibleData = isMobileStacked
      ? dataToRender.slice(0, mobileVisibleCount)
      : dataToRender;

    return groupGamesBySportTitle(visibleData).map(({ sportTitle }) =>
      getSportCategoryId(sportTitle)
    );
  }, [getFilteredGameLiveData, isMobileStacked, mobileVisibleCount]);

  const handleMobileShowMore = async () => {
    const nextCount = mobileVisibleCount + MOBILE_MATCHES_STEP;
    if (nextCount <= filteredGameCount) {
      setMobileVisibleCount(nextCount);
      return;
    }
    if (hasMore && !loading) {
      await fetchPage();
      setMobileVisibleCount((prev) => prev + MOBILE_MATCHES_STEP);
    }
  };

  const handleMobileShowLess = () => {
    setMobileVisibleCount(MOBILE_MATCHES_INITIAL);
    requestAnimationFrame(() => {
      betBuildContainerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  const mobileCanShowMore =
    isMobileStacked &&
    (mobileVisibleCount < filteredGameCount || (hasMore && !initialLoading));
  const mobileCanShowLess =
    isMobileStacked && mobileVisibleCount > MOBILE_MATCHES_INITIAL;

  return (
      <section className="staightPage">
        <div className="pageContentPart">
          {tabCount == 1 && (
            <>
              <div className="allSportsSlider">
                <AllSportsSlider data={getAllSportsData()} />
              </div>

              {!String(boardQuery || "").trim() && (
                <div className="sportsEventsSlider">
                  {bannersLoading ? (
                    <SportsEventsSliderSkeleton />
                  ) : (
                    <SportsEventsSlider data={primarySliderData} />
                  )}
                </div>
              )}

              <div className="filterContainer">
                <div className="filterSelect">
                  {/* <label htmlFor="">All Filter</label> */}
                  {/* <Select
                    placeholder=""
                    menuPosition="fixed"
                    value={selectedbookMarkOption}
                    onChange={handleSelectChange}
                    options={bookmakerOptions}
                    classNamePrefix="react-select__ninth"
                    isSearchable={false}
                  /> */}
                </div>

              </div>

              {selectedSport && (
                  <div className="radioSelectorWrapper">
                    <RadioSelector
                      options={options}
                      selectedKey={selectedGameKey?.key || "All"}
                      fetchDataForSelectedOption={(option) =>
                        fetchDataForSelectedOption(option, selectedSport)
                      }
                    />
                  </div>
                )}

              <div
                ref={straightBetListScrollRef}
                className={`staightPageCenterScroll${isMobileStacked ? " staightPageCenterScroll--mobile" : ""}`}
              >
              <div className="customAccordionWrapper">
                {/* Accordion items must be direct children — a Fragment wrapper
                    breaks open/toggle injection and leaves every league collapsed. */}
                <CustomAccordionWrapper multiple defaultOpen={expandedAccordionIds}>
                  {Array.isArray(gameLiveData) ? (
                    (() => {
                      const dataToRender = getFilteredGameLiveData();
                      const visibleData = isMobileStacked
                        ? dataToRender.slice(0, mobileVisibleCount)
                        : dataToRender;

                      const groupedGames = groupGamesBySportTitle(visibleData)
                        .map((group) => renderSportCategoryGroup(group))
                        .filter(Boolean);

                      if (initialLoading) {
                        // Keep the football Lottie loader. Empty-state copy
                        // stays gated below so it does not flash under it.
                        return <Loader />;
                      }
                      if (groupedGames.length > 0) {
                        return groupedGames;
                      }
                      return (
                        <div className="favorites-empty noDataFound text-center py-5">
                          <p className="favorites-empty__title fs16 mb-2">
                            {favoritesEmptyCopy.title}
                          </p>
                          {favoritesEmptyCopy.detail ? (
                            <p className="favorites-empty__detail fs13 mb-0">
                              {favoritesEmptyCopy.detail}
                            </p>
                          ) : null}
                        </div>
                      );
                    })()
                  ) : (
                    <div className="noDataFound fs15 text-center py-5">
                      Currently No Data Found
                    </div>
                  )}
                </CustomAccordionWrapper>
                {isMobileStacked && !initialLoading && filteredGameCount > 0 && (
                  <div className="mobile-matches-pagination">
                    {mobileCanShowMore && (
                      <button
                        type="button"
                        className="mobile-matches-pagination__btn"
                        onClick={handleMobileShowMore}
                        disabled={loading}
                      >
                        {loading ? "Loading…" : "Show More Matches"}
                      </button>
                    )}
                    {mobileCanShowLess && (
                      <button
                        type="button"
                        className="mobile-matches-pagination__btn mobile-matches-pagination__btn--secondary"
                        onClick={handleMobileShowLess}
                      >
                        Show Less
                      </button>
                    )}
                  </div>
                )}
              </div>
              </div>
            </>
          )}

          {tabCount == 2 && (

            <>
              <div className="tabHeader d-flex align-items-center">
                <button className="" onClick={() => tabNavigateHandle(1)}>
                  <IoIosArrowBack />
                </button>
                <div className="w-100 text-center">
                  <h4 className="fs14 text-uppercase">
                    {selectedTeam.home_team} vs {selectedTeam?.away_team}
                  </h4>
                </div>
              </div>
              <div className="staightPageCenterScroll staightPageCenterScroll--detail">
              <div
                className={
                  phoneShellEnabled
                    ? "eventMainDetailPart eventMainDetailPart--phone"
                    : "eventMainDetailPart"
                }
              >
                <div className="mainViewDetails">
                  <div className="detailsMiddlePart">
                    <div className="teamCard">
                      <div>
                        <TeamLogo
                          teamName={selectedTeam.home_team}
                          logoUrl={selectedTeam.home_team_logo}
                          size="lg"
                          alt={selectedTeam.home_team}
                        />
                      </div>
                      <h3 className="fs18 mt-3 mb-1">{selectedTeam.home_team}</h3>
                    </div>
                    <div className="content2 match-detail-tv">
                      <div
                        className="tvBgImg"
                        onClick={() => showFullDetailHandle(selectedTeam)}
                      >
                        <div className="tvStatusBadge">
                          <MatchStatus
                            matchTime={selectedTeam?.commence_time}
                            game={selectedTeam}
                          />
                        </div>
                        <div className="game-card-live-score">
                          <MatchLiveScorePanel
                            game={selectedTeam}
                            phase={UpcomingStatus(
                              selectedTeam?.commence_time,
                              selectedTeam
                            )}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="teamCard">
                      <div>
                        <TeamLogo
                          teamName={selectedTeam?.away_team}
                          logoUrl={selectedTeam?.away_team_logo}
                          size="lg"
                          alt={selectedTeam?.away_team}
                        />
                      </div>
                      <h3 className="fs18 mt-3 mb-1">{selectedTeam?.away_team}</h3>
                    </div>
                  </div>
                </div>
                {/* Featured board markets first; + More below. League filters stay on the list view only.
                    Match list shows one preferred bookmaker — detail does the same (no stacked duplicate cards). */}
                <div className="customAccordionWrapper">
                  <CustomAccordionWrapper defaultOpen={["main-item-1"]}>
                    {(() => {
                      const items = getPreferredBookmaker(selectedTeam?.bookmakers);
                      if (!items) return null;
                      const i = Math.max(
                        0,
                        (selectedTeam?.bookmakers || []).findIndex((b) => b.key === items.key)
                      );
                      const parentId = selectedTeam.id;
                      const h2hMarket = items.markets?.find((m) => m?.key === "h2h");
                      const h2hSides = h2hMarket
                        ? resolveH2hSides(
                            h2hMarket,
                            selectedTeam.home_team,
                            selectedTeam.away_team
                          )
                        : null;
                      const h2hMarketIndex = h2hMarket
                        ? items.markets.findIndex((m) => m?.key === "h2h")
                        : -1;

                      const renderDetailH2hCheckbox = (outcomeIndex, drawLabel = null) => {
                        if (!h2hMarket || outcomeIndex < 0) return <p>-</p>;
                        const outcome = h2hMarket.outcomes[outcomeIndex];
                        return (
                          <label
                            htmlFor={`market-${items.key}-${parentId}-h2h-${outcomeIndex}`}
                          >
                            <input
                              type="checkbox"
                              id={`market-${i}-${h2hMarketIndex}-${outcomeIndex}`}
                              onChange={(e) =>
                                handleChangeOnClickGame(
                                  e,
                                  selectedTeam,
                                  h2hMarket,
                                  i,
                                  h2hMarketIndex,
                                  outcomeIndex
                                )
                              }
                            />
                            {drawLabel ? <h3 className="fs13">{drawLabel}</h3> : null}
                            <h3 className="fs13">{formatOdds(outcome?.price)}</h3>
                          </label>
                        );
                      };

                      return (
                        <CustomAccordionItem
                          key={items.key || i}
                          id="main-item-1"
                          className="custom-item"
                        >
                          <CustomAccordionHeader className="custom-header" arrowtext="View All">
                            <div className="headerDetailsPart">
                              <div className="d-flex align-items-center gap-2">
                                <ImageComponent staticImgSrc={"whiteFootbalIcon"} alt={"cricatIcon"} />
                                <p className="m-0 fs14">{selectedTeam.sport_title}</p>
                              </div>
                            </div>
                          </CustomAccordionHeader>

                          <CustomAccordionBody className="custom-body">

                            <div className="bodyDetailsPart">
                              <div className="detailTopPart detailTopPart--detailMarkets">
                                <div className="leftPart">
                                  <button
                                    type="button"
                                    className="starBtn"
                                    aria-label={
                                      favGames.some((g) => g.id === selectedTeam.id)
                                        ? "Remove from favorites"
                                        : "Add to favorites"
                                    }
                                    onClick={() => handleLikeButton(selectedTeam)}
                                  >
                                    <IoStar
                                      className="icon"
                                      fill={favGames.some(g => g.id === selectedTeam.id) ? "#FFDA00" : "gray"}
                                    />
                                  </button>
                                </div>
                              </div>
                              {/* <div className="leftPart dateText">
                                <p className="fs14 mg-text-gray1">Bookmarks:{" "}{items?.title}</p>
                              </div> */}

                              <div className="detailsMiddlePart">

                                <div className="content1">
                                  <div className="headingContent d-flex align-items-center gap-3">
                                    <TeamLogo teamName={selectedTeam.home_team} logoUrl={selectedTeam.home_team_logo} size="md" alt={selectedTeam.home_team} />
                                    <p className="fs15">{selectedTeam.home_team}</p>
                                  </div>
                                  <p className="fs14 py-1 px-2">vs</p>
                                  <div className="headingContent d-flex align-items-center gap-3">
                                    <TeamLogo teamName={selectedTeam?.away_team} logoUrl={selectedTeam?.away_team_logo} size="md" alt={selectedTeam?.away_team} />
                                    <p className="fs15">{selectedTeam?.away_team}</p>
                                  </div>
                                </div>

                                <div className="content3 ms-auto">
                                  <div className="headingTextPart">
                                    <ul className="d-flex align-items-center justify-content-between gap-2 m-0">
                                      <li className="fs15">Spread</li>
                                      <li className="fs15">{getFeaturedMarketLabel("h2h", isDTS())}</li>
                                      <li className="fs15">Total</li>
                                    </ul>
                                  </div>

                                  {/* First row */}
                                  <ul className="pointUlTag">
                                    <li>
                                      {items?.markets?.some((m) => m?.key === "spreads") ? (
                                        items.markets.map((market, index) =>
                                          market?.key === "spreads" ? (
                                            <label key={index} htmlFor={`market-${items.key}-${parentId}-0`}>
                                              <input
                                                type="checkbox"
                                                id={`market-${i}-${index}-0`}
                                                onChange={(e) =>
                                                  handleChangeOnClickGame(e, selectedTeam, market, i, index, 0)
                                                }
                                              />
                                              <h3 className="fs13">{formatPoint(market?.outcomes?.[0]?.point)}</h3>
                                              <p className="fs15">{formatOdds(market?.outcomes?.[0]?.price)}</p>
                                            </label>
                                          ) : null
                                        )
                                      ) : (
                                        <p>-</p>
                                      )}
                                    </li>

                                    <li className="inputCheckboxWrapper">
                                      {renderDetailH2hCheckbox(h2hSides?.home?.index ?? -1)}
                                    </li>

                                    <li>
                                      {items?.markets?.some((m) => m?.key === "totals") ? (
                                        items.markets.map((market, index) =>
                                          market?.key === "totals" ? (
                                            <label key={index} htmlFor={`market-${items.key}-${parentId}-0`}>
                                              <input
                                                type="checkbox"
                                                id={`market-${i}-${index}-0`}
                                                onChange={(e) =>
                                                  handleChangeOnClickGame(e, selectedTeam, market, i, index, 0)
                                                }
                                              />
                                              <h3 className="fs13">
                                                {formatTotalPoint(
                                                  market?.outcomes?.[0]?.point,
                                                  market?.outcomes?.[0]?.name
                                                )}
                                              </h3>
                                              <p className="fs15">{formatOdds(market?.outcomes?.[0]?.price)}</p>
                                            </label>
                                          ) : null
                                        )
                                      ) : (
                                        <p>-</p>
                                      )}
                                    </li>
                                  </ul>

                                  {h2hSides?.isThreeWay ? (
                                    <ul className="pointUlTag pointUlTag--draw">
                                      <li>
                                        <p>-</p>
                                      </li>
                                      <li className="inputCheckboxWrapper">
                                        {renderDetailH2hCheckbox(
                                          h2hSides.draw.index,
                                          getDrawDisplayLabel(h2hSides.draw.outcome?.name)
                                        )}
                                      </li>
                                      <li>
                                        <p>-</p>
                                      </li>
                                    </ul>
                                  ) : null}

                                  {/* Second row */}
                                  <ul className="pointUlTag">
                                    <li>
                                      {items?.markets?.some((m) => m?.key === "spreads") ? (
                                        items.markets.map((market, index) =>
                                          market?.key === "spreads" ? (
                                            <label key={index} htmlFor={`market-${items.key}-${parentId}-1`}>
                                              <input
                                                type="checkbox"
                                                id={`market-${i}-${index}-1`}
                                                onChange={(e) =>
                                                  handleChangeOnClickGame(e, selectedTeam, market, i, index, 1)
                                                }
                                              />
                                              <h3 className="fs13">{formatPoint(market?.outcomes?.[1]?.point)}</h3>
                                              <p className="fs15">{formatOdds(market?.outcomes?.[1]?.price)}</p>
                                            </label>
                                          ) : null
                                        )
                                      ) : (
                                        <p>-</p>
                                      )}
                                    </li>

                                    <li>
                                      {renderDetailH2hCheckbox(h2hSides?.away?.index ?? -1)}
                                    </li>

                                    <li>
                                      {items?.markets?.some((m) => m?.key === "totals") ? (
                                        items.markets.map((market, index) =>
                                          market?.key === "totals" ? (
                                            <label key={index} htmlFor={`market-${items.key}-${parentId}-1`}>
                                              <input
                                                type="checkbox"
                                                id={`market-${i}-${index}-1`}
                                                onChange={(e) =>
                                                  handleChangeOnClickGame(e, selectedTeam, market, i, index, 1)
                                                }
                                              />
                                              <h3 className="fs13">
                                                {formatTotalPoint(
                                                  market?.outcomes?.[1]?.point,
                                                  market?.outcomes?.[1]?.name
                                                )}
                                              </h3>
                                              <p className="fs15">{formatOdds(market?.outcomes?.[1]?.price)}</p>
                                            </label>
                                          ) : null
                                        )
                                      ) : (
                                        <p>-</p>
                                      )}
                                    </li>
                                  </ul>
                                </div>
                              </div>

                              {/* <div className="dateCardTemplate">
                                <div className="leftPart">
                                  <p className="fs14">{formatCommenceTime(selectedTeam.commence_time)}</p>
                                  <span className="fs12" style={{ cursor: 'default' }}>CST</span>
                                </div>
                              </div> */}
                              <div className="dateCardTemplate">
                                <GameDateDisplay dateTime={selectedTeam?.commence_time} />
                                {/* <div className="rightPart moreBetBtnPart">
                      <button className="fs13">
                        More Bets <IoIosArrowForward />
                      </button>
                    </div> */}
                              </div>
                            </div>
                          </CustomAccordionBody>
                        </CustomAccordionItem>
                      );
                    })()}
                  </CustomAccordionWrapper>

                </div>
                <EventExtraMarketsPanel
                  game={selectedTeam}
                  onToggleOutcome={teamsSelect}
                  isOutcomeSelected={isboxChecked}
                />
              </div>
              </div>
            </>
          )}
        </div>

        <>
          <div className="betBuildContainer" ref={betBuildContainerRef}>
            <div>
              <button className="mg-primary-btn fs14" style={{ pointerEvents: 'none' }}>{isDTS() ? `${getTerm("entry")} Builder` : "Bet Builder"}</button>
            </div>
            <div className="my-2">
              <BuilderSlider getCurrentSelectValue={getCurrentSelectValue} activeTab={betTabName} />
            </div>

            {console.log("ticketArr", CheckInd)}

            <div className="straightBetCardWrapper">
              {betTabName === "Straight Bet" && (
                <>
                  <ul>
                    {CheckInd && CheckInd?.[0]?.length > 0 ? (
                      CheckInd?.[0]?.map((item, index) => {
                        const pointOptions = buildBuyPointSelectOptions(item);
                        const buyPointIdx = findBuyPointOptionIndex(item, pointOptions);
                        const showBuyPoints = canShowBuyPointsUI(item, buyPointsMap);

                        return (
                          <>
                            <li key={`straight-${index}`} className="straightBetCard">
                              <div className="leftPart">
                                {console.log("handleRemoveBet", item, index)}
                                <button
                                  className=""
                                  onClick={(e) => {
                                    handleRemoveTab(item, index);
                                  }}
                                >
                                  <IoCloseOutline />
                                </button>
                              </div>
                              <div className="rightPart">
                                <div>
                                  {console.log("itemitem>>>>>", item)}
                                  <div className="mb-2">
                                    <div className="d-flex align-items-center gap-2">
                                      <ImageComponent
                                        staticImgSrc={"cricatIcon"}
                                      />
                                      <p className="fs12">
                                        {item.teamName}
                                        {/* <span className='mg-text-gray1'> (VS) </span> */}
                                        {/* Scotland */}
                                      </p>
                                    </div>
                                    <div className="d-flex align-items-center gap-4 mt-1">
                                      {item.type !== "h2h" ? (
                                        <p className="fs12 mb-0">
                                          {formatBetSlipPoint(item)}
                                        </p>
                                      ) : null}
                                      <p className="fs12 mb-0">
                                        {formatOdds(item.bookPrice ?? item.originalPrice ?? item.price)}
                                      </p>
                                    </div>
                                  </div>
                                </div>

                                <>
                                  <div className="mb-1">
                                    <label className="fs12 mg-test-gray1">
                                      {item.marketLabel
                                        ? item.marketLabel
                                        : getFeaturedMarketLabel(item.type, isDTS())}
                                    </label>
                                  </div>

                                  {showBuyPoints ? (
                                    <div className="mb-2 buy-points-options">
                                      <div className="d-flex align-items-center gap-1 mb-1">
                                        <label className="fs12 mg-test-gray1 mb-0">{getBuyPointsLabel(isDTS())}</label>
                                        <IoInformationCircleOutline className="fs14 mg-text-gray1" aria-hidden="true" />
                                      </div>
                                      <select
                                        className="w-100 inputStyle1 fs12"
                                        value={buyPointIdx}
                                        onChange={(e) => {
                                          const opt = pointOptions[Number(e.target.value)];
                                          if (opt) handlePoints(opt, index, 0);
                                        }}
                                      >
                                        {pointOptions.map((opt) => (
                                          <option key={opt.value} value={opt.value}>{opt.label}</option>
                                        ))}
                                      </select>
                                    </div>
                                  ) : null}

                                  <div className="d-flex justify-content-between">
                                    <p className="fs12 mg-text-gray1">
                                      {item?.homeTeam} (vs) {item?.awayTeam}
                                    </p>
                                    <p className="fs12 mg-text-gray1">{formatEventKickoffUpperCase(item?.gameTime)}</p>
                                  </div>

                                  {/* RISK & WIN INPUTS */}
                                  <div className="fs12 d-flex gap-2 my-2">
                                    <input
                                      className="riskAndWin"
                                      type="text"
                                      inputMode="numeric"   // mobile numeric keyboard
                                      placeholder={`Risk - ${wagerAmount(0)}`}
                                      maxLength={MAX_BET_DIGITS}
                                      value={item?.risk > 0 ? item?.risk : ""}
                                      onChange={(e) =>
                                        handleNumberInput(e.target.value, (val) =>
                                          straightpayOutCalc(
                                            val,
                                            item.price,
                                            0,
                                            index,
                                            "risk"
                                          )
                                        )
                                      }
                                    />

                                    <input
                                      className="riskAndWin"
                                      type="text"
                                      inputMode="numeric"
                                      placeholder={`Win - ${wagerAmount(0)}`}
                                      maxLength={MAX_BET_DIGITS}
                                      value={item?.win ? item?.win : ""}
                                      onChange={(e) =>
                                        handleNumberInput(e.target.value, (val) =>
                                          straightpayOutCalc(
                                            val,
                                            item.price,
                                            0,
                                            index,
                                            "win"
                                          )
                                        )
                                      }
                                    />

                                  </div>

                                  {/* PAYOUT */}
                                  {item?.payout > 0 && (
                                    <div className="fs14 d-flex gap-2 my-2">
                                      <p className="mg-text-green1 fs14">
                                        {prizeAmountLabel()} {wagerAmount(item.payout)}
                                      </p>
                                    </div>
                                  )}
                                </>


                                {/* <div className='staightTicketWrapper'>
                                                                        <StaightTicket />
                                                                    </div> */}
                              </div>
                            </li>
                          </>
                        );
                      })
                    ) : (
                      <>
                        <p className="fs12 mt-3 text-center">
                        Select Spread, {getFeaturedMarketLabel("h2h", isDTS())}, or Total from any match to <br /> {isDTS() ? `add it to your ${getTerm("entry", { case: "lower" })} slip.` : "add it to your bet slip."}
                        </p>
                      </>
                    )}
                  </ul>
                  {CheckInd && CheckInd?.[0]?.length > 0 ? (
                    <>
                      <div className="d-flex justify-content-between gap-2 my-0">
                        <p className="fs12 mg-text-gray1">
                          Total Risk
                        </p>
                        <p className="fs12 riskAndWin">
                          {wagerAmount(totalRisk)}
                        </p>
                      </div>
                      <div className="d-flex justify-content-between gap-2 my-0">
                        <p className="fs12 mg-text-gray1">
                          Total Win
                        </p>
                        <p className="fs12 riskAndWin">
                          {wagerAmount(totalWin)}
                        </p>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                  <div className="py-2">
                    {CheckInd && CheckInd?.[0]?.length > 0 ? (
                      <div>
                        <AcceptOddsChangesControl
                          checked={acceptOddsChanges}
                          onChange={setAcceptOddsChanges}
                        />
                        <button
                          className="mg-primary-btn fs14"
                          // disabled={totalbetamount > 0 || totalbetamount == 0}
                          onClick={() => {
                            addNewOrder(CheckInd[0], "straight");
                          }}
                        >
                          {isDTS() ? `Submit All ${getTerm("entry", { plural: true })}` : "Submit All Bet"}
                        </button>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </>
              )}

              {betTabName === "Parlay Bet" && (
                <>
                  <ul>
                    <div className="rightPart">
                      {betTabName === "Parlay Bet" ? (
                        <div className="d-flex gap-2 align-items-center justify-content-between">
                          {/* <lable className="fs13 mg-text-gray1">
                            Open Spots
                          </lable>
                          <input
                            placeholder="0"
                            className="w-25 inputStyle2"
                            value={openSpot}
                            onChange={(e) => {
                              setOpenSpotsCount(e.target.value);
                            }}
                          /> */}
                        </div>
                      ) : (
                        ""
                      )}
                    </div>

                    {/* [...Array(ticketArr)].map((item, index) => ( */}
                    {CheckInd && CheckInd?.[0]?.length > 0 ? (
                      CheckInd[0]?.map((item, index) => {
                        return (
                          <>
                            <li className="straightBetCard">
                              <div className="leftPart">
                                <button
                                  className=""
                                  onClick={(e) => {
                                    handleRemoveTab(item, index);
                                  }}
                                >
                                  <IoCloseOutline />
                                </button>
                              </div>

                              <div className="rightPart">
                                <div>
                                  <div className="mb-1">
                                    <div className="d-flex align-items-center gap-2">
                                      <ImageComponent
                                        staticImgSrc={"cricatIcon"}
                                      />
                                      <p className="fs12">{item.teamName}</p>
                                    </div>
                                    <div className="d-flex align-items-center gap-4">
                                      {item.type !== "h2h" ? (
                                        <p className="fs12">{formatBetSlipPoint(item)}</p>
                                      ) : null}
                                      <p className="fs12">{formatOdds(item.price)}</p>
                                    </div>
                                  </div>

                                  <div className='mb-2'>
                                    <label className='fs13 mg-text-gray1'>
                                      {item.marketLabel
                                        ? item.marketLabel
                                        : getFeaturedMarketLabel(item.type, isDTS())}
                                    </label>
                                  </div>

                                  <div className="mb-1 d-flex justify-content-between">
                                    <div className="mb-1 d-flex justify-content-between">
                                      <p className="fs12 mg-text-gray1">
                                        {item && item?.homeTeam}{" "}(vs){' '}{item && item.awayTeam}
                                      </p>
                                    </div>
                                    {/* <p className="fs12 mg-text-gray1">
                                      {formatEventKickoffUpperCase(item?.gameTime)}
                                    </p> */}
                                  </div>
                                  <div className="mb-1 d-flex justify-content-between">
                                    <div className="mb-1 d-flex justify-content-between">
                                      {/* <p className="fs12 mg-text-gray1">
                                        Odds Price: $
                                        {BetPrice ? BetPrice : item.price}{" "}
                                      </p> */}
                                    </div>
                                  </div>
                                  <div>
                                    <div className="w-100">
                                      {/* <div className="fs12 d-flex gap-2 my-2">
                                        <p className="riskAndWin">
                                          Risk - ${Risk}
                                        </p>
                                        <p className="riskAndWin">
                                          Win - ${Win}
                                        </p>
                                      </div> */}

                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                          </>
                        );
                      })
                    ) : (
                      <p className="fs12 mt-3 text-center">
                        Select Spread, {getFeaturedMarketLabel("h2h", isDTS())}, or Total from any match to <br /> {isDTS() ? `add it to your ${getTerm("entry", { case: "lower" })} slip.` : "add it to your bet slip."}
                      </p>
                    )}
                  </ul>
                  {CheckInd && CheckInd?.[0]?.length > 0 ? (
                    <div className="py-2">
                      <div className="parlay-slip-footer">
                        <div className="parlay-slip-footer__meta">
                          <span className="parlay-slip-footer__legs">
                            {CheckInd[0].length} Legs
                          </span>
                          <span className="parlay-slip-footer__odds">
                            Odds{" "}
                            <strong>
                              {CheckInd[0].length >= PARLAY_MIN_LEGS &&
                              parlayHasValidLegPrices
                                ? formatAmericanOdds(parlayCombinedOdds)
                                : "—"}
                            </strong>
                          </span>
                        </div>
                        <input
                          className="inputStyle2 parlay-slip-footer__stake"
                          placeholder={wagerAmount(0)}
                          value={totalBet ?? ""}
                          onChange={(e) => handleParlayChange(e.target.value)}
                        />
                      </div>

                      {CheckInd[0].length >= PARLAY_MIN_LEGS &&
                        !parlayHasValidLegPrices && (
                          <p className="fs11 text-center text-warning mb-2">
                            One or more legs are missing valid odds.
                          </p>
                        )}

                      {CheckInd[0].length < PARLAY_MIN_LEGS && (
                        <p className="fs11 text-center text-danger mb-2">
                          {parlayMinLegsMessage(PARLAY_MIN_LEGS)}
                        </p>
                      )}

                      <div className="parlay-slip-payout-row">
                        <p className="mg-text-green1 fs12 mb-0">
                          {prizeAmountLabel()} {wagerAmount(parlayDisplayPayout)}
                        </p>
                        <button
                          type="button"
                          onClick={() => setIsOpen(true)}
                          className="fs11 cursor-pointer text-decoration-underline parlay-slip-calc-link"
                        >
                          {isDTS()
                            ? `${getEntryTypeLabel("Parlay", true)} Calculator`
                            : "Parlay Calculator"}
                        </button>
                      </div>

                      <div>
                        <AcceptOddsChangesControl
                          checked={acceptOddsChanges}
                          onChange={setAcceptOddsChanges}
                        />
                        <button
                          className="mg-primary-btn fs14"
                          disabled={
                            CheckInd[0].length < PARLAY_MIN_LEGS ||
                            !parlayHasValidLegPrices ||
                            !Number(totalBet) ||
                            Number(totalBet) <= 0
                          }
                          onClick={() => {
                            addNewOrder(CheckInd[0], "parlay");
                          }}
                        >
                          {isDTS() ? `Submit All ${getTerm("entry", { plural: true })}` : "Submit All Bet"}
                        </button>
                      </div>
                    </div>
                  ) : null}
                </>
              )}

              {betTabName === "Teaser" && (
                <>
                  {Array.isArray(CheckInd?.[0]) && CheckInd[0].length > 0 ? (
                    <>
                      {/* Header Section — same leftPart/rightPart/columns shell as rows */}
                      <ul>
                        <li className="straightBetCard teaser-slip-header-row" aria-hidden="true">
                          <div className="leftPart">
                            <button type="button" tabIndex={-1} disabled>
                              <IoCloseOutline />
                            </button>
                          </div>
                          <div className="rightPart teaser-slip-row">
                            <div className="teaser-slip-columns">
                              <ImageComponent staticImgSrc="cricatIcon" />
                              <div className="teaser-slip-team" />
                              <div className="teaser-slip-metrics fs13">
                                <p className="mb-0">Original</p>
                                <p className="mb-0">Points</p>
                                <p className="mb-0">New Line</p>
                              </div>
                            </div>
                          </div>
                        </li>

                        {/* List of Teaser Items */}
                        {CheckInd[0].map((item, ind) => (
                          <li key={ind} className="straightBetCard">
                            <div className="leftPart">
                              <button onClick={() => handleRemoveTab(item, ind)}>
                                <IoCloseOutline />
                              </button>
                            </div>

                            <div className="rightPart teaser-slip-row">
                              <div className="teaser-slip-columns">
                                <ImageComponent staticImgSrc="cricatIcon" />
                                <div className="teaser-slip-team">
                                  <p className="fs12 mb-0 text-truncate">{item.teamName}</p>
                                </div>
                                <div className="teaser-slip-metrics">
                                  <p className="fs12 text-secondary mb-0">
                                    {item.originalPoint !== undefined && item.originalPoint !== null && item.originalPoint !== "" && item.originalPoint !== "-"
                                      ? item.type === "totals"
                                        ? formatTotalPoint(
                                            item.originalPoint,
                                            item.pointType || item.teamName
                                          )
                                        : formatPoint(item.originalPoint)
                                      : "-"}
                                  </p>
                                  <p className="fs12 text-success fw-bold mb-0">
                                    {item.type === "h2h"
                                      ? "-"
                                      : (Number.isFinite(Number(item.buyPoints)) ? item.buyPoints : teaserPoints)}
                                  </p>
                                  <p className="fs12 mb-0">
                                    {item.type === "h2h" || !Number.isFinite(Number(item.adjustedPoint))
                                      ? "-"
                                      : item.type === "totals"
                                        ? formatTotalPoint(
                                            item.adjustedPoint,
                                            item.pointType || item.teamName
                                          )
                                        : formatPoint(item.adjustedPoint)}
                                  </p>
                                </div>
                              </div>

                              <div className="pt-2">
                                <div className="mt-2 d-flex flex-column align-items-start">
                                  <p className="fs12 mg-text-gray1">
                                    {item.marketLabel
                                      ? item.marketLabel
                                      : getFeaturedMarketLabel(item.type, isDTS())}
                                  </p>
                                  <p className="fs12 mg-text-gray1">
                                    {item.homeTeam} (vs) {item.awayTeam}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </li>
                        ))}
                      </ul>

                      {/* Main Teaser Section */}
                      <div>
                        {(() => {
                          const hasH2H = CheckInd[0].some((i) => i.type === "h2h");
                          const teamCount = CheckInd[0].length;
                          const canSubmit = !hasH2H && teamCount >= 2;

                          // ⚙️ show warning message
                          if (teamCount < 2) {
                            return (
                              <p className="fs12 mt-3 text-center text-danger">
                                Select at least two teams to continue.
                              </p>
                            );
                          }

                          if (hasH2H) {
                            return (
                              <p className="fs12 mt-3 text-center text-danger">
                                {teaserMoneylineBlockedMessage()}
                              </p>
                            );
                          }

                          return null;
                        })()}

                        {CheckInd[0].length > 1 && (
                          <>
                            {/* <CustomRangeComponent
                              value={teaserPoints}
                              onChange={(val) => setTeaserPoints(val)}
                            /> */}
                            <CustomRangeComponent
                              value={teaserPoints}
                              allowedValues={supportedTeaserPoints}
                              onChange={(val) => {
                                setTeaserPoints(val);
                                updateAllTeaserItems(totalTeaserBet, CheckInd[0].length, val);
                              }}
                            />

                            <div className="my-2 d-flex justify-content-between">
                              <div>
                                <p className="fs13 mb-0">
                                  {CheckInd[0].length} Team{" "}
                                  {Number.isFinite(Number(teaserPoints))
                                    ? teaserPoints
                                    : (supportedTeaserPoints[0] ?? 6)}{" "}
                                  {isDTS()
                                    ? getEntryTypeLabel("Teaser", true)
                                    : "Point Teaser"}
                                </p>
                                {teaserChartResult.ok && (
                                  <p className="fs11 text-secondary mb-0">
                                    {formatTeaserChartLabel(teaserChartKey)} chart
                                  </p>
                                )}
                              </div>

                              <div className="w-25 d-flex gap-2 align-items-center justify-content-between">
                                <p className="fs13">
                                  {formatTeaserAmericanOddsDisplay(
                                    getTeaserAmericanOdds(
                                      teaserChartKey,
                                      CheckInd[0].length,
                                      teaserPoints
                                    )
                                  )}
                                </p>
                                <div className="fs14">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    placeholder={wagerAmount(0)}
                                    className="inputStyle2 w-100"
                                    maxLength={MAX_BET_DIGITS + 3}
                                    value={totalTeaserBet}
                                    onChange={(e) => {
                                      const nextValue = e.target.value;
                                      if (nextValue === "") {
                                        settotalTeaserBet("");
                                        return;
                                      }
                                      if (!/^\d*\.?\d*$/.test(nextValue)) return;
                                      const intPart = nextValue.split(".")[0] || "";
                                      if (intPart.length > MAX_BET_DIGITS) return;
                                      if (Number(nextValue) > MAX_BET_AMOUNT) return;
                                      updateAllTeaserItems(nextValue, CheckInd[0].length, teaserPoints);
                                    }}

                                  />
                                </div>
                              </div>
                            </div>

                            <div className="mt-2 d-flex justify-content-between">
                              <p className="mg-text-gray1 fs13">Total Stake</p>
                              <p className="fs13">{wagerAmount(totalTeaserBet || 0)}</p>
                            </div>

                            <div className="my-2 d-flex justify-content-between">
                              <p className="mg-text-gray1 fs13">{isDTS() ? `Total ${getTerm("prize")}` : "Total Payout"}</p>
                              <p className="fs13">
                                {wagerAmount(
                                  calcTeaserPayout(
                                    Number(totalTeaserBet) || 0,
                                    CheckInd[0].length,
                                    teaserPoints
                                  )
                                )}
                              </p>
                            </div>

                            {errormsg && (
                              <p className="fs12 text-danger">{errormsg}</p>
                            )}

                            {/* ✅ Submit Button */}
                            <div className="pt-3">
                              <AcceptOddsChangesControl
                                checked={acceptOddsChanges}
                                onChange={setAcceptOddsChanges}
                              />
                              <button
                                className="mg-primary-btn fs14"
                                disabled={
                                  CheckInd[0].length < 2 ||
                                  CheckInd[0].some((i) => i.type === "h2h")
                                }
                                onClick={() => addNewOrder(CheckInd[0], "teaser")}
                              >
                                {isDTS() ? `Submit All ${getTerm("entry", { plural: true })}` : "Submit All Bet"}
                              </button>
                            </div>
                          </>
                        )}
                      </div>
                    </>
                  ) : (
                    <p className="fs12 mt-3 text-center">
                      {isDTS() ? `Please select ${getTerm("play", { case: "lower" })} teams` : "Please select betting teams"}
                    </p>
                  )}
                </>
              )}

              {betTabName === "Call Bets" && (
                <>
                  <CallBetSlipBuilder
                    items={CheckInd?.[0] || []}
                    totalRisk={totalRisk}
                    totalWin={totalWin}
                    maxBetDigits={MAX_BET_DIGITS}
                    onRemove={handleRemoveTab}
                    onDesiredLineChange={updateDesiredLine}
                    onDesiredPriceChange={updateDesiredPrice}
                    onRiskChange={(val, price, g, i) =>
                      handleNumberInput(val, (v) =>
                        straightpayOutCalc(v, price, g, i, "risk")
                      )
                    }
                    onWinChange={(val, price, g, i) =>
                      handleNumberInput(val, (v) =>
                        straightpayOutCalc(v, price, g, i, "win")
                      )
                    }
                    onSubmit={() => addNewOrder(CheckInd[0], "straight")}
                  />
                  <hr className="call-bet-divider" />
                  <CallBetsBetBuilderPanel
                    isActive={betTabName === "Call Bets"}
                    refreshKey={callBetListRefreshKey}
                  />
                </>
              )}

            </div>
            <div className="recentAccordionWrapper">
              <hr className="recentHrTag" />
              <CustomAccordionWrapper multiple defaultOpen={[]}>
                <CustomAccordionItem id="favoritesItem" className="">
                  <CustomAccordionHeader className="recentItemHeader">
                    <div className="d-flex align-items-center gap-2">
                      <ImageComponent staticImgSrc={"favoritesIcon"} />
                      <p className="fs13 fw-400">Favorites</p>
                    </div>
                  </CustomAccordionHeader>
                  <CustomAccordionBody
                    className="favRecentAccordionBody"
                    scrollMaxHeight={280}
                  >
                    {sidebarFavorites.length > 0 ? (
                      sidebarFavorites.map((item) => (
                        <FavRecentMatchCard
                          key={`fav-${item.id}`}
                          item={item}
                          sportIconMaps={sportIconMaps}
                          onOpen={handleFavRecentGameSelect}
                        />
                      ))
                    ) : (
                      <p className="fs12 text-center my-3 recent-empty-msg">
                        No favorite matches
                      </p>
                    )}
                  </CustomAccordionBody>
                </CustomAccordionItem>
                <CustomAccordionItem id="recentsItem" className="" autoScroll={true}>
                  <CustomAccordionHeader className="recentItemHeader">
                    <div className="d-flex align-items-center justify-content-between w-100 pe-2">
                      <div className="d-flex align-items-center gap-2">
                        <ImageComponent staticImgSrc={"favoritesIcon"} />
                        <p className="fs13 fw-400">Recents</p>
                      </div>
                      {sidebarRecents.length > 0 && (
                        <button
                          type="button"
                          className="recent-clear-all-btn"
                          onClick={(e) => {
                            e.stopPropagation()
                            handleClearAllRecents()
                          }}
                        >
                          Clear All
                        </button>
                      )}
                    </div>
                  </CustomAccordionHeader>
                  <CustomAccordionBody
                    className="favRecentAccordionBody"
                    scrollMaxHeight={280}
                  >
                    {sidebarRecents.length > 0 ? (
                      sidebarRecents.map((item) => (
                        <FavRecentMatchCard
                          key={`recent-${item.id}`}
                          item={item}
                          sportIconMaps={sportIconMaps}
                          onOpen={handleFavRecentGameSelect}
                          onRemove={handleRemoveRecentGame}
                        />
                      ))
                    ) : (
                      <p className="fs12 text-center my-3 recent-empty-msg">
                        Select Spread, {getFeaturedMarketLabel("h2h", isDTS())}, or Total from a match to add it here
                      </p>
                    )}
                  </CustomAccordionBody>
                </CustomAccordionItem>
              </CustomAccordionWrapper>
            </div>
          </div>
          <CalculatorModel
            show={isOpen}
            setShow={setIsOpen}
            mode={betTabName === "Parlay Bet" ? "parlay" : "straight"}
            selections={CheckInd?.flat() || []}
            onRemoveSelection={(item, index) => handleRemoveTab(item, index)}
            onApplyRisk={(amount) => {
              if (betTabName === "Parlay Bet") {
                handleParlayChange(String(amount));
                return;
              }
              const flat = CheckInd?.flat() || [];
              flat.forEach((it, i) => {
                if (it?.price !== undefined && it?.price !== null) {
                  const payoutPrice =
                    betTabName === "Call Bets"
                      ? resolveCallBetPriceForPayout(it) ?? it.price
                      : it.price;
                  straightpayOutCalc(amount, payoutPrice, 0, i, "risk");
                }
              });
            }}
          />
        </>
      </section>
  );
}

export default function StaightBetPageRoute(props) {
  return (
    <DashboardLayout>
      <StaightBetPage {...props} />
    </DashboardLayout>
  );
}
